import _ from "lodash";
import moment from "moment";
import update from "immutability-helper";

import { Sentry } from "services/sentry";
import { isIdEqual } from "Utils/idHelpers";
import { generateRandomIdV2 } from "Utils/GenerateRandomId";
import {
  getOrganizationId,
  getUserId,
  getDefaultNameSortPreference,
  getSelectedCurriculumId,
  getDefaultStudentNameOrderPreference,
} from "modules/CommonSelectors";
import { getAIResponse, goToRelativeRoute } from "modules/Services";
import {
  getUserInfo,
  setToastMsg,
  setMessagingChatId,
} from "Login/modules/LoginModule";
import client from "lib/apolloClient/client";
import { cache } from "lib/apolloClient";
import { getTaggedUserIds } from "Utils/RegexHelper";
import { getIsAdminTab } from "Announcements/modules/utils";

import {
  getIsCombineCurriculumHomePageEnabled,
  goToFamilyProfileRoute,
  navigateToTeacherProfile,
  TEACHER_PROFILE_NAV_CONTEXT,
  goToStudentProfileRoute,
} from "modules/NavigationModule";

import { PARENT, STAFF, STUDENT } from "Constants/stringConstants";
import {
  getUserReaction,
  getInitialDraftData,
  MESSAGE_STATUS,
  getUnreadChatsCountQueryVariables,
  scrollOnlyIfNearBottom,
  getMessageDOMId,
  getChatContainer,
  scrollToBottomInChat,
  addAttachmentsInDraftState,
  getChatDetailsQueryVariables,
  CHAT_TYPE,
  getFormattedNameForUserType,
  CHAT_TYPE_BE,
  getChannelListQueryVariables,
  getIsLocalMessage,
  PAGINATION_LIMITS,
  recordMessageV2ChannelCreation,
  MESSAGING_MODULE_CHANNEL_CREATED_FROM,
  CHAT_TYPE_ENUM,
  AI_MESSAGING_FIELD_AND_ACTION,
  MESSAGE_TYPE,
  MESSAGING_AI_ACTIONS,
  MESSAGING_SECTIONS,
  QUERY_PARAMS,
  getIsAIDebugModeEnabled,
  isMessagingRevempEnabled,
  getIsAIGenerateEnabled,
  getChatListQueryVariables,
  showActionButtonInNotification,
  isMessagingRevampV2Enabled,
  getChatAndChannelListQueryVariables,
  isReadReceiptOptimizationEnabled,
  isConnectOptimisticAblyCallEnabled,
  INTERACTION_TYPE,
  canAdminDeleteMessage,
  canStaffDeleteMessage,
  getMessagingFormRoute,
  getMessagingFormTemplateRoute,
  isChatNearBottom,
  getMessagingBaseRoute,
} from "./Utils";
import { getUserBasicDetailsFromCache } from "modules/CommonGraphqlHelpers";
import {
  createMessageMutation,
  createPersonalChatMutation,
  createFamilyChannelMutation,
  updateMessageMutation,
  updateChannelMutation,
  toggleChatMuteMutation,
  markMessageV2ReadMutation,
  createMessageReactionMutation,
  removeMessageReactionMutation,
  leaveChannelMutation,
  deleteMessageV2Mutation,
  createChannelMutation,
  updateChannelSettingMutation,
  createConversationSummaryMutation,
  createCustomChannelAndMoveMessagesMutation,
  forwardMessageMutation,
  joinChannelMutation,
  createDepartmentChannelMutation,
  updateDepartmentChannelMutation,
  markMessageV3ReadMutation,
  createPollMessageMutation,
  createPollResponseMutation,
  deleteInteractionMutation,
  duplicateInteractionMutation,
  forwardInteractionMutation,
  updateInteractionSettingsMutation,
  insertUserChatActivityLogMutation,
} from "./MessagingMutation";

import {
  getChatConversationsFromCache,
  writeChatConversationsToCache,
  readMessageFromCache,
  writeMessageToCache,
  getChatDetailsFromCache,
  writeChatDetailsToCache,
  getDepartmentsFromCache,
  writeDepartmentDetailsToCache,
  getUserViewOnlyFromCache,
  writeUserViewOnlyToCache,
} from "./MessagingGraphqlHelper";

import {
  getChatConversationsQuery,
  getMessageQuery,
  getMessageReactionsQuery,
  getMessageReadStateQuery,
  getChatMessagesReadStateQuery,
  getLatestUnreadStateQuery,
  getGradeUsersByTypeQuery,
  getSearchedMembersInChatQuery,
  getInteractionListQuery,
} from "./MessagingQuery";
import {
  getChatListQuery,
  getChannelListQuery,
  getChatUnreadCountQuery,
  getChatAndChannelListQuery,
  getChatAndChannelByIdQuery,
  getChatByIdQuery,
  getChannelThreadIemByIdQuery,
} from "MessagingV2/components/ThreadList/Utils/ThreadListQueries";

import {
  getChannelListFromCache,
  getChatAndChannelListFromCache,
  getChatListFromCache,
  getChatUnreadCountQueryFromCache,
  writeChannelListToCache,
  writeChatAndChannelListToCache,
  writeChatUnreadCountToCache,
} from "../components/ThreadList/Utils/ThreadListGraphqlHelpers";
import { DEPARTMENT_STATUSES } from "MessagingV2/routes/StaffDirectory/modules/utils";

export const NAME = "messagingV2";

export const UPDATE_DRAFT = `UPDATE_DRAFT_${NAME}`;
export const ADD_DRAFT_ATTACHMENTS = `ADD_DRAFT_ATTACHMENTS_${NAME}`;
export const SET_CHAT_FILTERS = `SET_CHAT_FILTERS_${NAME}`;
export const CLEAR_DRAFT = `CLEAR_DRAFT_${NAME}`;

export const SET_MESSAGE_STATUS = `SET_MESSAGE_STATUS_${NAME}`;
export const SET_SEGMENT_CHAT_TYPE = `SET_SEGMENT_CHAT_TYPE_${NAME}`;
export const SET_LAST_READ = `SET_LAST_READ_${NAME}`;
export const SET_MESSAGING_SECTIONS = `SET_MESSAGING_SECTIONS_${NAME}`;

export const UPDATE_SEARCH_TEXT = `SEARCH_TEXT_${NAME}`;
export const SET_IS_LOADING = `SET_IS_LOADING_${NAME}`;
export const SET_IS_SEARCHING = `SET_IS_SEARCHING_${NAME}`;
const SET_SUMMARY_GENERATION_STATUS = `SET_SUMMARY_GENERATION_STATUS_${NAME}`;
const PRESERVE_SCROLL_MESSAGE_ID = `PRESERVE_SCROLL_MESSAGE_ID_${NAME}`;
const SET_SUGGESTION_GENERATION_REQUESTED = `SET_SUGGESTION_GENERATION_REQUESTED_${NAME}`;
const SET_SUGGESTION_GENERATION_COMPLETED = `SET_SUGGESTION_GENERATION_COMPLETED_${NAME}`;
const REMOVE_CHAT_SUGGESTIONS = `REMOVE_CHAT_SUGGESTIONS_${NAME}`;
const UPDATE_SEARCH_V2_TAGS = `UPDATE_SEARCH_V2_TAGS_${NAME}`;
const UPDATE_SEARCH_V2_TEXT = `UPDATE_SEARCH_V2_TEXT_${NAME}`;
const UPDATE_SEARCH_V2_LAST_TAB = `UPDATE_SEARCH_V2_LAST_TAB_${NAME}`;
const SET_IS_SEARCH_CHAT_LOADING = `SET_IS_SEARCH_CHAT_LOADING_${NAME}`;
const SET_SHOW_UNREAD_MESSAGE_BUTTON = `SET_SHOW_UNREAD_MESSAGE_BUTTON_${NAME}`;
const SET_MEDIA_VIEWER_MODAL_STATE = `SET_MEDIA_VIEWER_MODAL_STATE_${NAME}`;
const SET_SHOW_SUMMARISE_NEW_MESSAGES_WITH_AI = `SET_SHOW_SUMMARISE_NEW_MESSAGES_WITH_AI_${NAME}`;
const SET_CREATE_CHANNEL_DROPDOWN_OPEN = `SET_CREATE_CHANNEL_DROPDOWN_OPEN_${NAME}`;
const SET_MESSAGE_REVAMP_V2_FILTER_SEARCH = `SET_MESSAGE_REVAMP_V2_FILTER_SEARCH_${NAME}`;
const SET_MESSAGE_REVAMP_V2_FILTER_THREAD = `SET_MESSAGE_REVAMP_V2_FILTER_THREAD_${NAME}`;
const SET_MESSAGE_REVAMP_V2_SEARCH_FOCUS = `SET_MESSAGE_REVAMP_V2_SEARCH_FOCUS_${NAME}`;
const SET_SHOW_OVERVIEW_MODAL = `SET_SHOW_OVERVIEW_MODAL_${NAME}`;
const SET_INIT_ADD_MEMBER_MODAL = `SET_INIT_ADD_MEMBER_MODAL_${NAME}`;
const SET_INIT_FORM_SUBMITTED_MODAL = `SET_INIT_FORM_SUBMITTED_MODAL_${NAME}`;
const SET_FORM_TEMPLATE_MODAL_STATE = `SET_FORM_TEMPLATE_MODAL_STATE_${NAME}`;

const UPDATE_DEPARTMENT_SEARCH_TEXT = `UPDATE_DEPARTMENT_SEARCH_TEXT_${NAME}`;
const UPDATE_DEPARTMENT_STATUS = `UPDATE_DEPARTMENT_STATUS_${NAME}`;

export const getMessagingV2ReduxState = state => state[NAME];
export const getDepartmentReduxState = state => state[NAME].department;

export const writeToChatAndChannelInCache = ({
  isNotificationOfPersonalChat,
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: isNotificationOfPersonalChat
        ? getChatListQuery
        : getChannelListQuery,
      variables,
      data,
    });
  } catch (err) {}
};

export const handleNewMessage = ({ chatId, chatType }) => {
  return async (_dispatch, getState) => {
    if (!chatId || !chatType) {
      return;
    }

    const state = getState();
    const organizationId = getOrganizationId();
    const messagingState = getMessagingV2ReduxState(state);
    const activeChatSegment = isMessagingRevempEnabled()
      ? _.get(state, "messagingV2.selectedSectionV2")
      : _.get(messagingState, "chatTypeSegment");
    const isNotificationOfPersonalChat =
      chatType === CHAT_TYPE_ENUM.CHAT_PERSONAL;

    let chatResponse;
    if (isMessagingRevampV2Enabled()) {
      if (!_.includes([CHAT_TYPE.CHAT, CHAT_TYPE.CHANNEL], activeChatSegment)) {
        return;
      }

      try {
        chatResponse = await client.query({
          query: getChatAndChannelByIdQuery,
          variables: { chatId, organizationId, portalType: "PLANNER" },
          fetchPolicy: "network-only",
        });

        let chatNode = _.get(chatResponse, "data.node");

        // If user is currently viewing this chat, force unreadMessageCount to 0
        if (getChatContainer(chatId)) {
          chatNode = { ...chatNode, unreadMessageCount: 0 };
        } else {
          // Preserve optimistic unreadMessageCount if higher than server value
          // (server may return stale data from replica DB)
          try {
            const cachedChat = _.find(
              _.get(
                getChatAndChannelListFromCache(
                  getChatAndChannelListQueryVariables()
                ),
                "node.chats.edges",
                []
              ),
              edge => isIdEqual(_.get(edge, "node.id"), chatId)
            );
            const cachedUnread = _.get(
              cachedChat,
              "node.unreadMessageCount",
              0
            );
            const serverUnread = _.get(chatNode, "unreadMessageCount", 0);
            if (cachedUnread > serverUnread) {
              chatNode = { ...chatNode, unreadMessageCount: cachedUnread };
            }
          } catch (e) {
            // ignore — proceed with server value
          }
        }

        const variables = getChatAndChannelListQueryVariables();
        const cachedData = getChatAndChannelListFromCache(variables);

        if (_.isEmpty(cachedData)) {
          return;
        }

        const chats = _.get(cachedData, "node.chats.edges", []);
        const chatsWithoutNewChat = _.filter(
          chats,
          chat => !isIdEqual(_.get(chat, "node.id"), chatId)
        );

        const newChats = [
          { node: chatNode, __typename: "ChatEdge" },
          ...chatsWithoutNewChat,
        ];

        const updatedData = update(cachedData, {
          node: {
            chats: { edges: { $set: newChats } },
          },
        });

        writeChatAndChannelListToCache({
          variables,
          data: updatedData,
        });
      } catch (err) {
        Sentry.captureMessage(`${err.message}`, {
          extra: {
            functionName: "handleNewMessageWithRevampV2",
            variables: isNotificationOfPersonalChat
              ? { chatId, organizationId, portalType: "PLANNER" }
              : { chatId, portalType: "PLANNER" },
            response: chatResponse,
            reason: "errorBlock",
          },
        });
      }
    } else {
      const selectedUserTypes = _.get(messagingState, [
        CHAT_TYPE.CHAT,
        "selectedUserTypes",
      ]);
      const selectedChannelTypes = _.get(messagingState, [
        CHAT_TYPE.CHANNEL,
        "selectedChannelTypes",
      ]);

      if (!_.includes([CHAT_TYPE.CHAT, CHAT_TYPE.CHANNEL], activeChatSegment)) {
        return;
      }

      try {
        chatResponse = await client.query({
          query: isNotificationOfPersonalChat
            ? getChatByIdQuery
            : getChannelThreadIemByIdQuery,
          variables: isNotificationOfPersonalChat
            ? { chatId, organizationId, portalType: "PLANNER" }
            : { chatId, portalType: "PLANNER" },
          fetchPolicy: "network-only",
        });

        let chatNode = _.get(chatResponse, "data.node");

        // If user is currently viewing this chat, force unreadMessageCount to 0
        if (getChatContainer(chatId)) {
          chatNode = { ...chatNode, unreadMessageCount: 0 };
        } else {
          // Preserve optimistic unreadMessageCount if higher than server value
          try {
            const cachedFeedData = isNotificationOfPersonalChat
              ? getChatListFromCache(getChatListQueryVariables())
              : getChannelListFromCache({
                  variables: getChannelListQueryVariables(),
                });
            const cachedChat = _.find(
              _.get(cachedFeedData, "node.chats.edges", []),
              edge => isIdEqual(_.get(edge, "node.id"), chatId)
            );
            const cachedUnread = _.get(
              cachedChat,
              "node.unreadMessageCount",
              0
            );
            const serverUnread = _.get(chatNode, "unreadMessageCount", 0);
            if (cachedUnread > serverUnread) {
              chatNode = { ...chatNode, unreadMessageCount: cachedUnread };
            }
          } catch (e) {
            // ignore — proceed with server value
          }
        }

        const { personalChatReceiverUser } = chatNode;
        const personalChatReceiverUserType = _.get(
          personalChatReceiverUser,
          "type"
        );

        const allFeedVariables = isNotificationOfPersonalChat
          ? getChatListQueryVariables()
          : getChannelListQueryVariables();

        const activeFeedVariables =
          activeChatSegment === CHAT_TYPE.CHAT
            ? getChatListQueryVariables({ userType: selectedUserTypes })
            : getChannelListQueryVariables({
                channelType: selectedChannelTypes,
              });

        const isNotificationAboutActiveFeed = isNotificationOfPersonalChat
          ? _.includes(selectedUserTypes, personalChatReceiverUserType)
          : _.includes(selectedChannelTypes, chatType);

        const feedVariableVariants =
          isNotificationAboutActiveFeed &&
          !_.isEqual(allFeedVariables, activeFeedVariables)
            ? [allFeedVariables, activeFeedVariables]
            : [allFeedVariables];

        _.forEach(feedVariableVariants, feedVariables => {
          const cachedFeedData = isNotificationOfPersonalChat
            ? getChatListFromCache(feedVariables)
            : getChannelListFromCache({ variables: feedVariables });

          if (_.isEmpty(cachedFeedData)) {
            // The data has not been queried even once and no cache present for this query.
            return;
          }

          const chats = _.get(cachedFeedData, "node.chats.edges", []);
          const chatsWithoutNewChat = _.filter(
            chats,
            chat => !isIdEqual(_.get(chat, "node.id"), chatId)
          );

          const newChats = [
            { node: chatNode, __typename: "ChatEdge" },
            ...chatsWithoutNewChat,
          ];

          const updatedData = update(cachedFeedData, {
            node: {
              chats: { edges: { $set: newChats } },
            },
          });

          writeToChatAndChannelInCache({
            isNotificationOfPersonalChat,
            variables: feedVariables,
            data: updatedData,
          });
        });
      } catch (err) {
        Sentry.captureMessage(`${err.message}`, {
          extra: {
            functionName: "handleNewMessage",
            variables: isNotificationOfPersonalChat
              ? { chatId, organizationId, portalType: "PLANNER" }
              : { chatId, portalType: "PLANNER" },
            response: chatResponse,
            reason: "errorBlock",
          },
        });
      }
    }
  };
};

export const updateDepartmentSearchText = data => {
  return {
    type: UPDATE_DEPARTMENT_SEARCH_TEXT,
    data,
  };
};

export const updateDepartmentStatus = data => {
  return {
    type: UPDATE_DEPARTMENT_STATUS,
    data,
  };
};

export const updateSearchText = data => {
  return {
    type: UPDATE_SEARCH_TEXT,
    data,
  };
};

export const setMediaViewerModalState = data => ({
  type: SET_MEDIA_VIEWER_MODAL_STATE,
  data,
});

const setSuggestionGenerationRequested = ({ chatId }) => ({
  type: SET_SUGGESTION_GENERATION_REQUESTED,
  payload: { chatId },
});

const setSuggestionGenerationCompleted = ({ chatId, suggestions }) => ({
  type: SET_SUGGESTION_GENERATION_COMPLETED,
  payload: { chatId, suggestions },
});

const removeChatSuggestions = ({ chatId }) => ({
  type: REMOVE_CHAT_SUGGESTIONS,
  payload: { chatId },
});

export const updateSearchV2Tags = data => {
  return {
    type: UPDATE_SEARCH_V2_TAGS,
    data,
  };
};

export const updateSearchV2Text = data => {
  return {
    type: UPDATE_SEARCH_V2_TEXT,
    data,
  };
};

export const updateSearchV2LastTab = data => {
  return {
    type: UPDATE_SEARCH_V2_LAST_TAB,
    data,
  };
};

export const setShowUnreadMessageButton = data => {
  return {
    type: SET_SHOW_UNREAD_MESSAGE_BUTTON,
    data,
  };
};

const mapUserTypeToTypename = {
  student: "Student",
  staff: "Staff",
  parent: "FamilyMember",
};

// { key: chatId, value: { usageMetricsId, intentUsageMetricsId, model, temperature } };
const summaryGenDebugModePropsMap = new Map();
const SUGGESTION_GENERATION_CANCEL_FUNCTIONS = new Map();

const removeSuggestionGenerationCancelFunction = chatId => {
  SUGGESTION_GENERATION_CANCEL_FUNCTIONS.delete(chatId);
};

const cancelSuggestionGeneration = chatId => {
  const cancelFunc = SUGGESTION_GENERATION_CANCEL_FUNCTIONS.get(chatId);
  if (_.isFunction(cancelFunc)) {
    cancelFunc();
    removeSuggestionGenerationCancelFunction(chatId);
  }
};

const addSuggestionGenerationCancelFunction = ({ chatId, cancelFunc }) => {
  SUGGESTION_GENERATION_CANCEL_FUNCTIONS.set(chatId, cancelFunc);
};

export const getDebugModePropsForSuggestions = chatId =>
  summaryGenDebugModePropsMap.get(chatId);

const removeAndCancelSuggestionGeneration = chatId => {
  return dispatch => {
    cancelSuggestionGeneration(chatId);
    dispatch(removeChatSuggestions({ chatId }));
  };
};

// this are used to optimistically update the message
const addReactionToMessage = ({ message, emojiObject, userInfo }) => {
  const { id: userId, first_name: firstName, user_type: type } = userInfo;
  const { id: emojiId, unified, skin } = emojiObject;

  const localId = `NEW_${generateRandomIdV2()}`;
  const newReactionObj = {
    id: localId,
    uid: emojiId, // eg "+1" for thumbsUp
    unified,
    skinTone: skin ?? null,
    createdBy: {
      id: userId,
      firstName,
      __typename: mapUserTypeToTypename[type],
    },
    __typename: "MessageV2Reaction",
  };

  const rollback = latestMessageState => ({
    ...latestMessageState,
    reactions: _.reject(_.get(latestMessageState, "reactions", []), r =>
      _.isEqual(r.id, localId)
    ),
  });

  return {
    updatedMessage: {
      ...message,
      reactions: [..._.get(message, "reactions", []), newReactionObj],
    },
    rollback,
  };
};

const removeReactionFromMessage = ({ message, unified, userInfo }) => {
  const { id: userId } = userInfo;
  const oldReactions = _.get(message, "reactions", []);

  let removedReactionData = null;
  const reactions = _.reject(oldReactions, (reaction, idx) => {
    if (
      _.isEqual(reaction.unified, unified) &&
      isIdEqual(_.get(reaction, "createdBy.id"), userId)
    ) {
      removedReactionData = { reaction, idx };
      return true;
    }
    return false;
  });

  const rollback = latestMessageState => {
    if (!removedReactionData) return latestMessageState;
    const { reaction, idx } = removedReactionData;

    return {
      ...latestMessageState,
      reactions: update(latestMessageState.reactions, {
        $splice: [[idx, 0, reaction]],
      }),
    };
  };

  return {
    updatedMessage: { ...message, reactions },
    rollback,
  };
};

const addReaction = ({ message, emojiObject, chatId }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo(state);
    const organizationId = getOrganizationId();

    const messageId = message.id;
    const { id: emojiId, skin: skinTone, unified } = emojiObject;

    const { updatedMessage, rollback } = addReactionToMessage({
      message,
      emojiObject,
      userInfo,
    });
    writeMessageToCache({ messageId, data: updatedMessage, organizationId });

    // Scroll to bottom if the message is last and if near bottom
    const messageElement = document.getElementById(getMessageDOMId(message));
    // TODO: change this approach if we decide to use virtualized list
    const isLastMessage = messageElement && !messageElement.nextSibling;
    if (isLastMessage) scrollOnlyIfNearBottom({ threshold: 10, chatId });

    try {
      await client.mutate({
        mutation: createMessageReactionMutation,
        variables: { input: { messageId, uid: emojiId, unified, skinTone } },
      });
      return true;
    } catch (err) {
      // read the latest message state from cache to avoid race condition
      const latestMessageState = readMessageFromCache({
        messageId,
        organizationId,
      });
      // revert the optimistic update
      writeMessageToCache({
        messageId,
        data: rollback(latestMessageState),
        organizationId,
      });

      if (err.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        // TODO: clarify for custom reaction failed message i18n
        dispatch(setToastMsg("toastMsgs:reaction_add_error"));
      }
      return false;
    }
  };
};

const removeReaction = ({ message, userReaction }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo(state);
    const messageId = message.id;
    const { unified } = userReaction;
    const organizationId = getOrganizationId();
    // optimistically remove reaction from the message
    const { updatedMessage, rollback } = removeReactionFromMessage({
      message,
      unified,
      userInfo,
    });
    writeMessageToCache({ messageId, data: updatedMessage, organizationId });

    try {
      await client.mutate({
        mutation: removeMessageReactionMutation,
        variables: {
          input: { messageId, unified },
        },
      });
      return true;
    } catch (err) {
      // read the latest message state from cache to avoid race condition
      const latestMessageState = readMessageFromCache({
        messageId,
        organizationId,
      });
      // revert the optimistic update
      writeMessageToCache({
        messageId,
        data: rollback(latestMessageState),
        organizationId,
      });

      if (err.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        // TODO: confirm customized error msg
        dispatch(setToastMsg("toastMsgs:reaction_remove_error"));
      }
      return false;
    }
  };
};

// This object will store all the current mutations for toggling reactions per message.
// Needed to avoid race conditions, by using this we'll wait for all the consecutive
// mutations to finish before querying the backend for the latest message state.
const messageReactionMutationsStore = {};
const addMutationIdentifier = ({ messageId, uId }) => {
  const messageSet = _.get(messageReactionMutationsStore, messageId, new Set());
  messageSet.add(uId);
  _.set(messageReactionMutationsStore, messageId, messageSet);
};

const removeMutationIdentifier = ({ messageId, uId }) => {
  const messageSet = _.get(messageReactionMutationsStore, messageId);
  if (!messageSet) return;

  messageSet.delete(uId);
  if (_.isEmpty(messageSet)) _.unset(messageReactionMutationsStore, messageId);
};

const isMutationInProgressForMessage = messageId => {
  return !_.isEmpty(_.get(messageReactionMutationsStore, messageId));
};

export const getLatestMessageStateIfNoMutations = async ({
  messageId,
  scrollChatId,
}) => {
  const organizationId = getOrganizationId();
  // Received notification for a message that is not in cache
  let message = readMessageFromCache({ messageId, organizationId });
  if (_.isEmpty(message)) return;

  if (isMutationInProgressForMessage(messageId)) return;

  // if there are no mutations in progress then
  // query the backend for latest message state
  try {
    const response = await client.query({
      query: getMessageReactionsQuery,
      variables: { id: messageId, portalType: "PLANNER" },
      fetchPolicy: "no-cache", // we'll update the cache manually if needed
      context: { useHttpLink: true },
    });

    // if there are any mutations in progress
    // then don't update the cache, it'll be refetch-ed
    // & updated after all the mutations are completed
    if (isMutationInProgressForMessage(messageId)) return;

    const messageNode = _.get(response, "data.node");
    if (!messageNode) return; // will never happen, but just in case

    message = readMessageFromCache({ messageId, organizationId });

    const messageElement = document.getElementById(getMessageDOMId(message));
    const isLastMessage = messageElement && !messageElement.nextSibling;
    if (!scrollChatId || !isLastMessage) {
      writeMessageToCache({
        messageId,
        data: { ...message, ...messageNode },
        organizationId,
      });
      return;
    }

    // write message to cache after scroll calculation and before scroll
    scrollOnlyIfNearBottom({
      threshold: 20,
      chatId: scrollChatId,
      afterCalculationCb: () => {
        writeMessageToCache({
          messageId,
          data: { ...message, ...messageNode },
          organizationId,
        });
      },
    });
  } catch (err) {}
};

export const toggleReaction = ({ messageId, emojiObject, chatId }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { id: emojiId } = emojiObject;
    const currentUserId = getUserId(state);
    const organizationId = getOrganizationId();

    const message = readMessageFromCache({ messageId, organizationId });
    const reactions = message.reactions ?? [];

    const userReaction = getUserReaction({
      comparatorKey: "uid",
      comparatorValue: emojiId,
      userId: currentUserId,
      allReactions: reactions,
    });

    // Generate a uId to identify this mutation and save in the store
    const uniqueMutationId = generateRandomIdV2();
    addMutationIdentifier({ messageId, uId: uniqueMutationId });

    const action = userReaction ? removeReaction : addReaction;
    await dispatch(action({ message, emojiObject, userReaction, chatId }));

    removeMutationIdentifier({ messageId, uId: uniqueMutationId });
    getLatestMessageStateIfNoMutations({ messageId });
  };
};

/**
 * @param {string} messageId
 * @param {onlyIfSentByCurrentUser} boolean
 * @returns { isLocalMessage: boolean, deletedMessage: object } | {} (empty object)
 * @description
 * This function is used to delete a message from the cache.
 */
export const deleteMessageInCache = ({
  chatId, // Only needed when message is local
  messageId,
  onlyIfSentByCurrentUser = false,
}) => {
  return (_dispatch, getState) => {
    const organizationId = getOrganizationId();
    const message = readMessageFromCache({ messageId, organizationId });

    // meaning message not found in cache
    // might have received event for a message that is not in cache yet)
    if (_.isEmpty(message)) return {};

    if (onlyIfSentByCurrentUser) {
      const userId = getUserId(getState());
      const isMessageSentByCurrentUser =
        isIdEqual(_.get(message, "createdBy.id"), userId) ||
        canAdminDeleteMessage() ||
        canStaffDeleteMessage();

      if (!isMessageSentByCurrentUser) return {};
    }

    const isLocalMessage = getIsLocalMessage(messageId);
    if (isLocalMessage) {
      if (!chatId) {
        // in case of local message, chatId is required
        return { isLocalMessage: true, deletedMessage: null };
      }

      const cachedData = getChatConversationsFromCache({
        id: chatId,
        organizationId,
      });
      const messages = _.get(cachedData, "messagesV2.edges", []);
      const newMessages = _.reject(messages, ({ node: messageNode }) =>
        isIdEqual(messageNode.id, messageId)
      );
      const organizationId = getOrganizationId();

      writeChatConversationsToCache({
        variables: { id: chatId, organizationId },
        chatConversationsData: {
          ...cachedData,
          messagesV2: {
            ...cachedData.messagesV2,
            edges: newMessages,
            totalCount: _.get(cachedData, "messagesV2.totalCount", 1) - 1,
          },
        },
      });

      return { isLocalMessage: true, deletedMessage: message };
    }

    const newMessage = {
      ...message,
      isDeleted: true,
      label: null,
      attachments: null,
      parentMessage: null,
      reactions: null,
    };
    setTimeout(() => {
      writeMessageToCache({ messageId, data: newMessage, organizationId });
    });

    return { isLocalMessage: false, deletedMessage: message };
  };
};

export const deleteMessage = ({ chatId, messageId }) => {
  return async dispatch => {
    // optimistically delete the message
    const { isLocalMessage, deletedMessage } = dispatch(
      deleteMessageInCache({
        chatId,
        messageId,
        onlyIfSentByCurrentUser: true,
      })
    );
    const organizationId = getOrganizationId();

    // if there is no message in cache then no need to make api call, just return
    if (!deletedMessage) return false;

    // if message is local then no need to make api call, just return
    if (isLocalMessage) return true;

    try {
      await client.mutate({
        mutation: deleteMessageV2Mutation,
        variables: { input: { id: messageId } },
      });
    } catch (err) {
      setTimeout(() => {
        writeMessageToCache({
          messageId,
          data: deletedMessage,
          organizationId,
        });
      });
      if (err.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        // TODO: confirm customized error msg
        dispatch(setToastMsg("toastMsgs:delete_message_error"));
      }
    }
  };
};

export const handleDuplicateTemplate = ({ queryVariables, templateId }) => {
  return async dispatch => {
    try {
      const currentQueryVariable = {
        ...queryVariables,
        input: _.omit(queryVariables.input, ["after"]),
      };

      await client.mutate({
        mutation: duplicateInteractionMutation,
        variables: {
          input: { interactionId: templateId },
          portalType: "PLANNER",
        },
        refetchQueries: [
          {
            query: getInteractionListQuery,
            variables: currentQueryVariable,
            portalType: "PLANNER",
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:entity_duplicated_successfully",
          locale_params: [
            {
              key: "entity",
              value: "common:template",
              isPlainText: false,
            },
          ],
          type: "success",
        })
      );
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const handleDeleteTemplate = ({ queryVariables, templateId }) => {
  return async dispatch => {
    try {
      const currentQueryVariable = {
        ...queryVariables,
        input: _.omit(queryVariables.input, ["after"]),
      };

      await client.mutate({
        mutation: deleteInteractionMutation,
        variables: {
          input: {
            id: templateId,
          },
          portalType: "PLANNER",
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            deleteInteraction: true,
            __typename: "PlatformMutations",
          },
        },
        update: cache => {
          cache.updateQuery(
            {
              query: getInteractionListQuery,
              variables: currentQueryVariable,
            },
            data => {
              const edges = _.get(data, "node.messageV2Interactions.edges");
              const updatedEdges = _.filter(
                edges,
                edge => _.get(edge, "node.id") !== templateId
              );

              const updatedData = update(data, {
                node: {
                  messageV2Interactions: {
                    edges: { $set: updatedEdges },
                  },
                },
              });

              return updatedData;
            }
          );
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:deleted_successfully",
          type: "success",
        })
      );
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const handleSearchNewChat = ({ id, queryParams }) => {
  return async dispatch => {
    dispatch(setSearchChatLoadingState(true));

    const chatId = await dispatch(createPersonalChat(id));

    if (chatId) {
      const queryParamsObj = new URLSearchParams(queryParams);
      queryParamsObj.set(QUERY_PARAMS.CHAT_ID, chatId);
      const queryParamsString = queryParamsObj.toString();

      dispatch(
        goToRelativeRoute({
          route: `members?${queryParamsString}`,
          type: "replace",
          replacePath: "members",
        })
      );
    }
    dispatch(setSearchChatLoadingState(false));

    return chatId;
  };
};

export const toggleChatMute = ({ id, isMuted, isChannel }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: toggleChatMuteMutation,
        variables: { id },
      });

      const msg = isChannel
        ? isMuted
          ? "toastMsgs:channel_unmuted_successfully"
          : "toastMsgs:channel_muted_successfully"
        : isMuted
        ? "toastMsgs:chat_unmuted_successfully"
        : "toastMsgs:chat_muted_successfully";

      dispatch(
        setToastMsg({
          msg,
          type: "success",
        })
      );
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const optimisticToggleChatMute = ({ chatId, isMuted, isChannel }) => {
  return async dispatch => {
    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId: getUserId(),
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    const updatedChatDetails = {
      ...chatDetailsCacheData,
      isMuted,
    };

    try {
      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetails,
      });

      await client.mutate({
        mutation: toggleChatMuteMutation,
        variables: { id: chatId },
      });

      const msg = isChannel
        ? isMuted
          ? "toastMsgs:channel_muted_successfully"
          : "toastMsgs:channel_unmuted_successfully"
        : isMuted
        ? "toastMsgs:chat_muted_successfully"
        : "toastMsgs:chat_unmuted_successfully";

      dispatch(
        setToastMsg({
          msg,
          type: "success",
        })
      );
    } catch (e) {
      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const hideMembersListForRoles = ({
  chatId,
  hideMembersListFromRoles,
}) => {
  return async dispatch => {
    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId: getUserId(),
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    const updatedChatDetails = {
      ...chatDetailsCacheData,
      memberListHiddenRoles: hideMembersListFromRoles,
    };

    try {
      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetails,
      });

      const response = await client.mutate({
        mutation: updateChannelSettingMutation,
        variables: {
          input: { chatId, hideMembersListFromRoles },
        },
      });
      const updatedMemberListHiddenRoles = _.get(
        response,
        "data.platform.updateChannelSettings.memberListHiddenRoles"
      );
      const msg = !_.includes(updatedMemberListHiddenRoles, PARENT)
        ? "toastMsgs:channel_member_list_visible"
        : "toastMsgs:channel_member_list_hidden";

      dispatch(
        setToastMsg({
          msg,
          type: "success",
        })
      );
    } catch (e) {
      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const handleCreateNewChat = ({
  id,
  isWidget,
  isFamilyChannel = false,
}) => {
  return async dispatch => {
    dispatch(setLoadingState(true));

    if (!isWidget) {
      dispatch(
        goToRelativeRoute({
          route: "messaging",
          type: "replace",
          replacePath: `messaging`,
        })
      );
    }

    const chatId = isFamilyChannel
      ? await dispatch(createFamilyChannel(id))
      : await dispatch(createPersonalChat(id));

    if (chatId) {
      if (isWidget) {
        dispatch(setMessagingChatId(chatId));
      } else {
        dispatch(goToChatIdRoute({ chatId }));
      }
    }

    dispatch(setLoadingState(false));

    return chatId;
  };
};

export const unarchiveOrJoinChannel = ({
  chatId,
  unarchiveChannel,
  joinChannel,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const currentUserId = getUserId(state);
    const organizationId = getOrganizationId();
    const userIdsToAdd = joinChannel ? [currentUserId] : undefined;
    const isArchived = unarchiveChannel ? false : undefined;

    try {
      await client.mutate({
        mutation: updateChannelMutation,
        variables: {
          input: {
            chatId,
            isArchived,
            userIdsToAdd,
          },
          organizationId,
        },
      });

      if (joinChannel) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:successfully_with_label",
            locale_params: [
              {
                key: "label",
                value: "toastMsgs:added",
                isPlainText: false,
              },
            ],
            type: "success",
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:action_successfully",
            locale_params: [
              {
                key: "label",
                value: "common:channel",
                isPlainText: false,
              },
              {
                key: "action",
                value: "toastMsgs:unarchived",
                isPlainText: false,
              },
            ],
            type: "success",
          })
        );
      }
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const handleArchiveDepartmentChannel = ({ chatId, isArchived }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId,
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    try {
      const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
        isArchived: {
          $set: isArchived ?? chatDetailsCacheData.isArchived,
        },
      });

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetailsCacheData,
      });

      const { isSuccess } = await dispatch(
        updateDepartmentChannel({ isArchived, chatId })
      );
      if (isSuccess) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:action_successfully",
            locale_params: [
              {
                key: "label",
                value: "common:channel",
                isPlainText: false,
              },
              {
                key: "action",
                value: isArchived
                  ? "toastMsgs:archived"
                  : "toastMsgs:unarchived",
                isPlainText: false,
              },
            ],
            type: "success",
          })
        );
        dispatch(handleMessagesChanges({ chatId }));
      }
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });
    }
  };
};

export const leaveDepartmentChannel = ({ chatId }) => {
  return async (dispatch, getState) => {
    const store = getState();
    const userId = getUserId(store);

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId,
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    try {
      const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
        totalUsersCount: {
          $set: chatDetailsCacheData.totalUsersCount - 1,
        },
        users: {
          $set: _.reject(chatDetailsCacheData.users, user =>
            isIdEqual(_.get(user, "id"), userId)
          ),
        },
      });

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetailsCacheData,
      });

      await client.mutate({
        mutation: updateDepartmentChannelMutation,
        variables: {
          input: {
            userIdsToRemove: [userId],
            chatId,
          },
          organizationId: getOrganizationId(),
        },
      });

      dispatch(
        handleNewMessage({
          chatId,
          chatType: CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
        })
      );

      dispatch(
        setToastMsg({
          msg: "toastMsgs:you_left_this_channel",
          type: "warning",
        })
      );
    } catch (e) {
      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

// created for public channel
export const leaveChannel = ({ chatId }) => {
  return async (dispatch, getState) => {
    const store = getState();
    const userId = getUserId(store);

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId,
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    try {
      const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
        totalUsersCount: {
          $set: chatDetailsCacheData.totalUsersCount - 1,
        },
        users: {
          $set: _.reject(chatDetailsCacheData.users, user =>
            isIdEqual(_.get(user, "id"), userId)
          ),
        },
      });

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetailsCacheData,
      });

      await client.mutate({
        mutation: leaveChannelMutation,
        variables: {
          input: {
            chatIds: [chatId],
          },
        },
      });

      dispatch(
        handleNewMessage({
          chatId,
          chatType: CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
        })
      );

      dispatch(
        setToastMsg({
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            {
              key: "label",
              value: "toastMsgs:removed",
              isPlainText: false,
            },
          ],
          type: "success",
        })
      );
    } catch (e) {
      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

// created for public channel
export const joinChannel = ({ chatId }) => {
  return async dispatch => {
    const organizationId = getOrganizationId();

    try {
      await client.mutate({
        mutation: joinChannelMutation,
        variables: {
          input: {
            chatIds: [chatId],
          },
          organizationId,
        },
      });

      dispatch(handleMessagesChanges({ chatId }));

      dispatch(
        handleNewMessage({
          chatId,
          chatType: CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
        })
      );
      dispatch(
        setToastMsg({
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            {
              key: "label",
              value: "toastMsgs:added",
              isPlainText: false,
            },
          ],
          type: "success",
        })
      );
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const addMembersInChannel = ({ chatId, users }) => {
  return async (dispatch, getState) => {
    const { isSuccess } = await dispatch(updateChannel({ chatId, users }));
    if (isSuccess) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:channel_information_updated",
          type: "success",
        })
      );
    }
    return isSuccess;
  };
};

export const addMembersInDepartmentChannel = ({ chatId, users }) => {
  return async dispatch => {
    const { isSuccess, userIdsToAdd = [] } = await dispatch(
      updateDepartmentChannel({ chatId, users })
    );
    if (isSuccess) {
      const isMember = _.lte(_.size(userIdsToAdd), 1);
      const msg = isMember
        ? "toastMsgs:member_added_successfully"
        : "toastMsgs:member_added_successfully_other";
      dispatch(
        setToastMsg({
          msg,
          type: "success",
        })
      );
    }
    return isSuccess;
  };
};

const getUserIdAndType = user => ({
  id: _.get(user, "node.id"),
  type: _.get(user, "node.type"),
});

const getGradeUsersIdAndType = _.memoize(grade => {
  const { courses } = grade;
  return _.reduce(
    _.get(courses, "edges", []),
    (acc, course) => {
      const { students = {}, collaborator = {}, familyMembers = {} } = _.get(
        course,
        "node",
        {}
      );

      const studentsList = _.map(
        _.get(students, "edges", []),
        getUserIdAndType
      );

      const collaboratorList = _.map(
        _.get(collaborator, "edges", []),
        getUserIdAndType
      );

      const familyMembersList = _.map(
        _.get(familyMembers, "edges", []),
        getUserIdAndType
      );

      acc.push(...studentsList);
      acc.push(...collaboratorList);
      acc.push(...familyMembersList);

      return acc;
    },
    []
  );
});

export const getGradeUsers = async ({ gradeId, userType }) => {
  try {
    const isStudents = _.isEqual(userType, STUDENT);
    const isParents = _.isEqual(userType, PARENT);
    const isStaffMembers = _.isEqual(userType, STAFF);

    const gradeUsers = await client.query({
      query: getGradeUsersByTypeQuery,
      variables: {
        gradeIds: [gradeId],
        isStudents,
        isParents,
        isStaffMembers,
        organizationId: getOrganizationId(),
      },
      fetchPolicy: "network-only",
    });
    const grade = _.first(_.get(gradeUsers, "data.node.grades", []));
    return getGradeUsersIdAndType(grade);
  } catch (err) {
    return [];
  }
};

// this thunk is being used in updating flow in channel dropdown (edit channel info , archive channel , manage users)
export const updateChannel = ({
  label,
  description,
  profileImage,
  chatId,
  isArchived,
  users,
}) => {
  return async (dispatch, getState) => {
    const organizationId = getOrganizationId();
    const userIds = users ? _.uniq(_.map(users, user => user.id)) : undefined;

    const state = getState();
    const userId = getUserId(state); // getting current user as this is not used in view mode

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId,
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    try {
      const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
        label: {
          $set: label ?? chatDetailsCacheData.label,
        },
        description: {
          $set: description ?? chatDetailsCacheData.description,
        },
        profileImage: {
          $set: profileImage ?? chatDetailsCacheData.profileImage,
        },
        isArchived: {
          $set: isArchived ?? chatDetailsCacheData.isArchived,
        },
        totalUsersCount: {
          $set: !_.isUndefined(users)
            ? _.size(users)
            : chatDetailsCacheData.totalUsersCount,
        },
        users: {
          $set: users ?? chatDetailsCacheData.users,
        },
      });

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetailsCacheData,
      });

      // TODO: optimistically add channel activity

      await client.mutate({
        mutation: updateChannelMutation,
        variables: {
          input: {
            label,
            description,
            profileImage,
            chatId,
            isArchived,
            userIds,
          },
          organizationId,
        },
      });

      dispatch(handleMessagesChanges({ chatId }));
      return { isSuccess: true };
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });
      return { isSuccess: false };
    }
  };
};

export const updateDepartmentChannel = ({
  chatId,
  isArchived,
  users,
  label,
  bannerMessage,
}) => {
  return async (dispatch, getState) => {
    const organizationId = getOrganizationId();

    const state = getState();
    const userId = getUserId(state);

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId,
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    try {
      const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
        label: {
          $set: label ?? chatDetailsCacheData.label,
        },
        bannerMessage: {
          $set: bannerMessage ?? chatDetailsCacheData.bannerMessage,
        },
        isArchived: {
          $set: isArchived ?? chatDetailsCacheData.isArchived,
        },
        totalUsersCount: {
          $set: !_.isUndefined(users)
            ? _.size(users)
            : chatDetailsCacheData.totalUsersCount,
        },
        users: {
          $set: users ?? chatDetailsCacheData.users,
        },
      });

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetailsCacheData,
      });

      const prevUsers = _.get(chatDetailsCacheData, "users", []);

      // Determine added and removed users
      const prevUserIds = new Set(_.map(prevUsers, "id"));
      const newUserIds = new Set(_.map(users, "id"));

      const userIdsToRemove = [...prevUserIds].filter(
        id => !newUserIds.has(id)
      );
      const userIdsToAdd = [...newUserIds].filter(id => !prevUserIds.has(id));

      await client.mutate({
        mutation: updateDepartmentChannelMutation,
        variables: {
          input: {
            chatId,
            label,
            bannerMessage,
            isArchived,
            ...(!_.isEmpty(users)
              ? {
                  userIdsToRemove,
                  userIdsToAdd,
                }
              : {}),
          },
          organizationId,
        },
      });

      dispatch(handleMessagesChanges({ chatId }));
      return { isSuccess: true, userIdsToAdd, userIdsToRemove };
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });
      return { isSuccess: false };
    }
  };
};

export const changeChannelToPrivate = ({ chatId, isPrivate }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const organizationId = getOrganizationId();
    const userId = getUserId(state);

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId,
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    try {
      const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
        type: {
          $set: isPrivate
            ? CHAT_TYPE_ENUM.CHANNEL_CUSTOM
            : CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
        },
      });

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: updatedChatDetailsCacheData,
      });

      await client.mutate({
        mutation: updateChannelMutation,
        variables: {
          input: {
            chatId,
            isPublic: !isPrivate,
          },
          organizationId,
        },
      });

      dispatch(
        handleMessagesChanges({
          chatId,
        })
      );
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );

      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });

      return { isSuccess: false };
    }
  };
};
export const handleEditChannelInfo = ({
  label,
  description,
  profileImage,
  chatId,
}) => {
  return async dispatch => {
    try {
      const { isSuccess } = await dispatch(
        updateChannel({ label, description, profileImage, chatId })
      );
      if (isSuccess) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:channel_information_updated",
            type: "success",
            position: "toast-bottom-left",
          })
        );
      }
    } catch (err) {}
  };
};

export const handleEditDepartmentChannelInfo = ({
  chatId,
  label,
  bannerMessage,
}) => {
  return async dispatch => {
    try {
      const { isSuccess } = await dispatch(
        updateDepartmentChannel({
          chatId,
          label,
          bannerMessage,
        })
      );
      if (isSuccess) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:channel_information_updated",
            type: "success",
            position: "toast-bottom-left",
          })
        );
      }
    } catch (err) {}
  };
};

export const handleManageMemberV2RemovedOrBlocked = ({
  user,
  variables,
  isRemoveFlow,
}) => {
  cache.updateQuery(
    {
      query: getSearchedMembersInChatQuery,
      variables,
    },
    data => {
      let finalData = data;

      if (isRemoveFlow) {
        const usersList = _.get(data, "node.usersV2.edges", []);
        const updatedUsersList = _.filter(usersList, userData => {
          const userId = _.get(userData, "node.id");
          return !isIdEqual(userId, user.id);
        });

        finalData = update(data, {
          node: {
            usersV2: {
              edges: {
                $set: updatedUsersList,
              },
            },
          },
        });

        return finalData;
      }
    }
  );
};

export const handleArchiveChannel = ({ isArchived, chatId }) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const messagingV2State = getMessagingV2ReduxState(state);

      const selectedChannelTypes = _.get(
        messagingV2State,
        [CHAT_TYPE.CHANNEL, "selectedChannelTypes"],
        []
      );

      const chatTypeSegment = _.get(messagingV2State, "chatTypeSegment");

      const allFeedVariables = getChannelListQueryVariables();

      const activeFeedVariables = getChannelListQueryVariables({
        channelTypes: selectedChannelTypes,
      });

      const feedVariableVariants =
        chatTypeSegment === CHAT_TYPE.CHANNEL &&
        !_.isEqual(allFeedVariables, activeFeedVariables)
          ? [allFeedVariables, activeFeedVariables]
          : [allFeedVariables];

      _.forEach(feedVariableVariants, feedVariables => {
        const cachedFeedData = getChannelListFromCache({
          variables: feedVariables,
        });
        if (_.isEmpty(cachedFeedData)) {
          // The data has not been queried even once and no cache present for this query.
          return;
        }

        const channels = _.get(cachedFeedData, "node.chats.edges", []);
        const channelWithOutArchivedChannel = _.filter(
          channels,
          channel => !isIdEqual(_.get(channel, "node.id"), chatId)
        );

        const updatedData = update(cachedFeedData, {
          node: {
            chats: { edges: { $set: channelWithOutArchivedChannel } },
          },
        });

        writeChannelListToCache({
          variables: feedVariables,
          data: updatedData,
        });
      });

      await dispatch(updateChannel({ isArchived, chatId }));
      dispatch(
        setToastMsg({
          msg: "toastMsgs:action_successfully",
          locale_params: [
            {
              key: "label",
              value: "common:channel",
              isPlainText: false,
            },
            {
              key: "action",
              value: "toastMsgs:archived",
              isPlainText: false,
            },
          ],
          type: "success",
        })
      );
    } catch (err) {}
  };
};

export const handleRemoveUserFromChannel = ({
  users,
  chatId,
  removedUser,
  callback,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const defaultStudentNameSortPreference = getDefaultNameSortPreference(
      state
    );
    const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
      state
    );
    try {
      await dispatch(updateChannel({ users, chatId }));
      const name = getFormattedNameForUserType({
        user: removedUser,
        orderBy: defaultStudentNameSortPreference,
        defaultStudentNameOrderPreference,
        isFormattedNameV2: true,
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:user_has_been_removed_from_the_channel",
          locale_params: [
            {
              key: "name",
              value: name,
              isPlainText: true,
            },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
    } finally {
      if (_.isFunction(callback)) callback();
    }
  };
};

export const handleRemoveUserFromDepartmentChannel = ({
  users,
  chatId,
  removedUser,
  callback,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const defaultStudentNameSortPreference = getDefaultNameSortPreference(
      state
    );
    try {
      await dispatch(updateDepartmentChannel({ users, chatId }));
      const name = getFormattedNameForUserType({
        user: removedUser,
        orderBy: defaultStudentNameSortPreference,
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:user_has_been_removed_from_the_channel",
          locale_params: [
            {
              key: "name",
              value: name,
              isPlainText: true,
            },
          ],
          type: "success",
        })
      );
    } catch (err) {
    } finally {
      if (_.isFunction(callback)) callback();
    }
  };
};

export const createChannel = ({
  label,
  description,
  userIds,
  profileImage,
  isPublic,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo(state);
    const { id: loggedInUserId } = userInfo;
    const updatedUsers = _.uniq([...userIds, loggedInUserId]);
    try {
      const result = await client.mutate({
        mutation: createChannelMutation,
        variables: {
          input: {
            label,
            description,
            profileImage,
            userIds: updatedUsers,
            isPublic,
          },
          organizationId: getOrganizationId(),
        },
      });

      const newChannelData = _.get(result, "data.platform.createCustomChannel");
      const { id, type } = newChannelData;

      // TODO: use the above queried data and prevent unnecessary query
      await dispatch(handleNewMessage({ chatId: id, chatType: type }));

      dispatch(
        setToastMsg({
          msg: "toastMsgs:successfully_created_the_channel_label",
          locale_params: [
            {
              key: "label",
              value: _.get(newChannelData, "label"),
              isPlainText: true,
            },
          ],
          type: "info",
          position: "toast-bottom-left",
        })
      );

      return _.get(newChannelData, "id");
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "top",
        })
      );
    }
  };
};

export const handleCreateChannel = ({
  label,
  description,
  userIds,
  isWidget,
  profileImage,
  isPublic,
}) => {
  return async dispatch => {
    dispatch(setLoadingState(true));

    if (!isWidget) {
      dispatch(
        goToRelativeRoute({
          route: "messaging",
          type: "replace",
          replacePath: `messaging`,
        })
      );
    }

    const channelId = await dispatch(
      createChannel({ label, description, userIds, profileImage, isPublic })
    );

    if (channelId) {
      if (isWidget) {
        dispatch(setMessagingChatId(channelId));
        recordMessageV2ChannelCreation({
          type: CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
          from: MESSAGING_MODULE_CHANNEL_CREATED_FROM.MAGIC_TRAY,
        });
      } else {
        dispatch(goToChatIdRoute({ chatId: channelId }));
        recordMessageV2ChannelCreation({
          type: CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
          from: MESSAGING_MODULE_CHANNEL_CREATED_FROM.MESSAGING_MODULE,
        });
      }
    }

    dispatch(setLoadingState(false));

    return channelId;
  };
};

export const handleCreateDepartmentChannel = ({ id, isWidget }) => {
  return async dispatch => {
    dispatch(setLoadingState(true));
    let channelId;

    if (!isWidget) {
      dispatch(
        goToRelativeRoute({
          route: "messaging",
          type: "replace",
          replacePath: `messaging`,
        })
      );
    }

    const initDepartmentsVariable = {
      organizationId: getOrganizationId(),
      input: {
        first: 20,
        channelJoinStatus: "NOT_JOINED",
      },
    };

    const departmentsCache = getDepartmentsFromCache(initDepartmentsVariable);

    try {
      if (departmentsCache) {
        // delete the department from cache
        const updatedDepartmentCache = update(departmentsCache, {
          connectDepartments: {
            edges: {
              $apply: edges =>
                edges.filter(edge => _.get(edge, "node.id") !== id),
            },
          },
        });

        writeDepartmentDetailsToCache({
          variables: initDepartmentsVariable,
          initDepartmentsVariable,
          data: updatedDepartmentCache,
        });
      }

      const mutationData = await client.mutate({
        mutation: createDepartmentChannelMutation,
        variables: {
          input: { departmentId: id },
        },
      });

      channelId = _.get(
        mutationData,
        "data.platform.createDepartmentChannel.id"
      );

      const isArchived = _.get(
        mutationData,
        "data.platform.createDepartmentChannel.isArchived"
      );

      if (channelId) {
        if (isWidget) {
          dispatch(setMessagingChatId(channelId));
          recordMessageV2ChannelCreation({
            type: CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT,
            from: MESSAGING_MODULE_CHANNEL_CREATED_FROM.MAGIC_TRAY,
          });
        } else {
          dispatch(goToChatIdRoute({ chatId: channelId }));

          recordMessageV2ChannelCreation({
            type: CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT,
            from: MESSAGING_MODULE_CHANNEL_CREATED_FROM.MESSAGING_MODULE,
          });

          dispatch(
            handleNewMessage({
              chatId: channelId,
              chatType: CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
            })
          );
        }
        if (!isArchived) {
          dispatch(setInitAddMemberModalId(channelId));
        }
        dispatch(
          setToastMsg({
            msg: "toastMsgs:name_created_successfully",
            locale_params: [
              {
                key: "name",
                value: "common:channel",
                isPlainText: false,
              },
            ],
            type: "success",
          })
        );
      }
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );

      if (departmentsCache) {
        writeDepartmentDetailsToCache({
          variables: initDepartmentsVariable,
          initDepartmentsVariable,
          data: departmentsCache,
        });
      }
    } finally {
      dispatch(setLoadingState(false));
    }

    return channelId;
  };
};

export const updateChannelSettings = ({ chatId, viewOnlyRoles }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateChannelSettingMutation,
        variables: {
          input: { chatId, viewOnlyRoles },
        },
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:channel_settings_updated",
          type: "success",
        })
      );
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const updateViewOnlyUsers = ({
  chatId,
  isBlocking,
  userId,
  userType,
  name,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId: getUserId(state),
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    const userCacheData = getUserViewOnlyFromCache({
      chatId,
      id: userId,
      userType,
    });
    try {
      const viewOnlyUsers = _.get(chatDetailsCacheData, "viewOnlyUsers", []);
      const updatedViewOnlyUsers = isBlocking
        ? _.uniqBy([...viewOnlyUsers, { id: userId }], "id")
        : _.filter(viewOnlyUsers, user => !isIdEqual(user.id, userId));

      if (!_.isNil(chatDetailsCacheData)) {
        const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
          viewOnlyUsers: {
            $set: updatedViewOnlyUsers,
          },
        });
        writeChatDetailsToCache({
          variables: chatDetailsQueryVariables,
          data: updatedChatDetailsCacheData,
        });
      }

      if (!_.isNil(userCacheData)) {
        const updatedUserCacheData = update(userCacheData, {
          isChatViewOnly: {
            $set: isBlocking,
          },
        });

        writeUserViewOnlyToCache({
          chatId,
          id: userId,
          userType,
          data: updatedUserCacheData,
        });
      }

      await client.mutate({
        mutation: updateChannelSettingMutation,
        variables: {
          input: { chatId, viewOnlyUsers: _.map(updatedViewOnlyUsers, "id") },
        },
      });

      dispatch(
        setToastMsg({
          msg: isBlocking
            ? "toastMsgs:name_blocked_success_msg"
            : "toastMsgs:name_unblocked_success_msg",
          locale_params: [
            {
              key: "name",
              value: name,
              isPlainText: false,
            },
          ],
          type: "success",
        })
      );
    } catch (e) {
      if (!_.isNil(chatDetailsCacheData)) {
        writeChatDetailsToCache({
          variables: chatDetailsQueryVariables,
          data: chatDetailsCacheData,
        });
      }
      if (!_.isNil(userCacheData)) {
        writeUserViewOnlyToCache({
          chatId,
          id: userId,
          userType,
          data: userCacheData,
        });
      }
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const updateChannelSettingV2 = ({ chatId, viewOnlyRoles }) => {
  return async dispatch => {
    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId: getUserId(),
    });
    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );
    try {
      if (!_.isEmpty(chatDetailsCacheData)) {
        const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
          viewOnlyRoles: {
            $set: viewOnlyRoles,
          },
        });

        writeChatDetailsToCache({
          variables: chatDetailsQueryVariables,
          data: updatedChatDetailsCacheData,
        });
      }
      await client.mutate({
        mutation: updateChannelSettingMutation,
        variables: {
          input: { chatId, viewOnlyRoles },
        },
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:channel_settings_updated",
          type: "success",
        })
      );
    } catch (e) {
      writeChatDetailsToCache({
        variables: chatDetailsQueryVariables,
        data: chatDetailsCacheData,
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const goToChatIdRoute = ({ type = "replace", chatId }) => {
  return dispatch => {
    dispatch(
      goToRelativeRoute({
        route: `messaging/${chatId}`,
        replacePath: `messaging`,
        type,
      })
    );
  };
};

export const createPersonalChat = userId => {
  return async dispatch => {
    try {
      const data = await client.mutate({
        mutation: createPersonalChatMutation,
        variables: { input: { userId } },
      });

      return _.get(data, "data.platform.createPersonalChat.id");
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const createFamilyChannel = studentId => {
  return async dispatch => {
    try {
      const data = await client.mutate({
        mutation: createFamilyChannelMutation,
        variables: { input: { studentId } },
      });

      return _.get(data, "data.platform.createFamilyChannel.id");
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const goToMessagingV2Route = ({ type } = {}) => (dispatch, getState) => {
  const state = getState();

  const navigationType = _.includes(["push", "replace"], type) ? type : "push";
  const curriculumId = getSelectedCurriculumId(state);

  const isAdminTab = getIsAdminTab(state);
  const isCombinedCurriculumHomePage = getIsCombineCurriculumHomePageEnabled();
  const baseRoute = getMessagingBaseRoute({
    isCombinedCurriculumHomePage,
    isAdminTab,
    curriculumId,
  });
  const route = `${baseRoute}/messaging`;

  dispatch(
    goToRelativeRoute({
      route,
      replacePath: "platform",
      type: navigationType,
    })
  );
};

export const goToMessagingV2FormRoute = ({
  type,
  chatId,
  formId,
  messageId,
  templateId,
}) => (dispatch, getState) => {
  const state = getState();
  const navigationType = _.includes(["push", "replace"], type) ? type : "push";
  const curriculumId = getSelectedCurriculumId(state);
  const isAdminTab = getIsAdminTab(state);
  const isCombinedCurriculumHomePage = getIsCombineCurriculumHomePageEnabled();

  const formRoute = getMessagingFormRoute({
    chatId,
    formId,
    messageId,
    templateId,
  });

  const baseRoute = getMessagingBaseRoute({
    isCombinedCurriculumHomePage,
    isAdminTab,
    curriculumId,
  });
  const route = `${baseRoute}/${formRoute}`;

  dispatch(
    goToRelativeRoute({
      route,
      replacePath: "platform",
      type: navigationType,
    })
  );
};

export const goToMessagingV2FormTemplateRoute = ({
  type,
  chatId,
  templateId,
  tabKey,
}) => (dispatch, getState) => {
  const state = getState();
  const navigationType = _.includes(["push", "replace"], type) ? type : "push";
  const curriculumId = getSelectedCurriculumId(state);
  const isAdminTab = getIsAdminTab(state);
  const isCombinedCurriculumHomePage = getIsCombineCurriculumHomePageEnabled();

  const formRoute = getMessagingFormTemplateRoute({
    chatId,
    templateId,
    tabKey,
  });

  const baseRoute = getMessagingBaseRoute({
    isCombinedCurriculumHomePage,
    isAdminTab,
    curriculumId,
  });
  const route = `${baseRoute}/${formRoute}`;

  dispatch(
    goToRelativeRoute({
      route,
      replacePath: "platform",
      type: navigationType,
    })
  );
};

export const goToPublicChannelsRoute = ({ type } = {}) => (
  dispatch,
  getState
) => {
  const state = getState();
  const navigationType = _.includes(["push", "replace"], type) ? type : "push";
  const curriculumId = getSelectedCurriculumId(state);
  const isAdminTab = getIsAdminTab(state);
  const isCombinedCurriculumHomePage = getIsCombineCurriculumHomePageEnabled();

  const baseRoute = getMessagingBaseRoute({
    isCombinedCurriculumHomePage,
    isAdminTab,
    curriculumId,
  });
  const route = `${baseRoute}/messaging/public-channels`;

  dispatch(
    goToRelativeRoute({
      route,
      replacePath: "platform",
      type: navigationType,
    })
  );
};

export const resetQueryParams = ({ type = "replace" } = {}) => dispatch => {
  dispatch(goToRelativeRoute({ route: "?", type }));
};

export const resetMessageQueryParams = ({
  type = "replace",
} = {}) => dispatch => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  urlSearchParams.delete(QUERY_PARAMS.MESSAGE_ID);
  urlSearchParams.delete(QUERY_PARAMS.MESSAGE_CURSOR);

  dispatch(
    goToRelativeRoute({
      route: `?${urlSearchParams.toString()}`,
      type,
    })
  );
};

const USER_BASIC_DETAILS_PICK_KEYS = [
  "id",
  "firstName",
  "middleName",
  "lastName",
  "profileImage",
  "__typename",
];

const replaceLocalMessage = ({ edges, newEdge, localMessageId }) => {
  let isMessageFound = false;
  const newEdges = _.map(edges, edge => {
    if (isIdEqual(_.get(edge, "node.id"), localMessageId)) {
      isMessageFound = true;
      return newEdge;
    }
    return edge;
  });

  // although this is not needed, but just in case
  if (!isMessageFound) newEdges.unshift(newEdge);
  return _.uniqBy(newEdges, "node.id");
};

// TODO: solve the rare race condition, when order gets out of sync with the server
export const createMessage = params => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const chatId = _.get(params, "chatId", "");
    const collaborators = _.get(params, "collaborators", []);
    const { id: userId } = userInfo;

    const label = _.trim(_.get(params, "label", ""));
    const attachments = _.get(params, "attachments", []);
    const parentMessage = _.get(params, "parentMessage", {});
    const parentMessageId = _.get(parentMessage, "id", null);
    const messageId = _.get(params, "id");
    const newMessageId = messageId || `NEW_${generateRandomIdV2()}`;
    const isResendFlow = !!messageId;

    const taggedUsers = getTaggedUserIds({
      comment: label,
      collaborators,
    });

    const organizationId = getOrganizationId();
    if (_.isEmpty(attachments) && _.isEmpty(label)) return;

    if (!isResendFlow) {
      dispatch(clearDraft(chatId));
    }

    dispatch(
      setMessageStatus({
        messageId: newMessageId,
        status: MESSAGE_STATUS.SENDING,
      })
    );

    const { user_type: userType } = userInfo;

    const attachmentCreatedBy = _.includes(["student", "staff"], userType)
      ? _.capitalize(userType)
      : "FamilyMember";

    const newAttachments = _.map(attachments, attachment => {
      return {
        id: generateRandomIdV2(),
        thumbUrl: null,
        title: null,
        streamUrl: null,
        signedUrl: null,
        metadata: null,
        interaction: null,
        parentType: "MESSAGE_ITEM",
        createdBy: {
          id: generateRandomIdV2(),
          type: userType,
          __typename: attachmentCreatedBy,
        },
        ...attachment,
        __typename: "Attachment",
      };
    });

    const now = moment().toISOString();

    const newMessage = {
      id: newMessageId,
      label,
      isRead: false,
      isDeleted: false,
      cursor: null,
      type: "NORMAL",
      attachments: newAttachments,
      isFlagged: false,
      summaryRange: null,
      reactions: [],
      createdBy: {
        ..._.pick(
          getUserBasicDetailsFromCache({
            id: userInfo.id,
            type: userInfo.userEntityType,
          }),
          USER_BASIC_DETAILS_PICK_KEYS
        ),
        // only active user can send message anyways
        isArchived: false,
        isDeleted: false,
        type: userType,
      },
      createdAt: now,
      updatedAt: now,
      parentMessage: !_.isEmpty(parentMessage)
        ? {
            ...parentMessage,
            __typename: "MessageV2",
          }
        : null,
      channelActivity: null,
      __typename: "MessageV2",
    };

    const attachmentsInput = _.map(attachments, attachment => ({
      ..._.omit(attachment, [
        "streamUrl",
        "__typename",
        "signedUrl",
        "interaction",
      ]),
      createdBy: _.get(attachment, "createdBy.id", userId),
    }));

    const variables = {
      createMessageV2Input: {
        chatId,
        label: _.trim(label),
        taggedUsers,
        attachments: attachmentsInput,
        parentMessageId,
        showNotificationActionButtons: showActionButtonInNotification(),
      },
      organizationId,
    };

    try {
      let mainData = getChatConversationsFromCache({
        id: chatId,
        organizationId,
      });

      if (isResendFlow) {
        const messagesNode = _.get(mainData, "messagesV2.edges", []);
        const failedMessageIndex = _.findIndex(messagesNode, messageNode =>
          isIdEqual(newMessageId, _.get(messageNode, "node.id"))
        );
        if (failedMessageIndex !== -1) {
          mainData = update(mainData, {
            messagesV2: {
              edges: { $splice: [[failedMessageIndex, 1]] },
            },
          });
        }
      }

      // add the new local message optimistically
      let edges = _.get(mainData, "messagesV2.edges", []);
      const pageInfo = _.get(mainData, "messagesV2.pageInfo", {});
      const previousCount = _.get(mainData, "messagesV2.totalCount", 0);
      const hasNextPage = _.get(
        mainData,
        "messagesV2.pageInfo.hasNextPage",
        false
      );

      let messageV2Edge = {
        cursor: null,
        node: newMessage,
        __typename: "MessageV2Edge",
      };

      // reset all the server messages if hasNextPage is true
      // and show only the local(in progress) messages, by appending this new one
      // and call fetchOldMessages in the component.
      const edgesToPreserve = hasNextPage
        ? _.filter(edges, edge => getIsLocalMessage(_.get(edge, "node.id")))
        : edges;

      const newEdges = [messageV2Edge, ...edgesToPreserve];
      const newPageInfo = hasNextPage
        ? {
            ...pageInfo,
            hasPreviousPage: true,
            hasNextPage: false,
            startCursor: null,
            endCursor: null,
          }
        : pageInfo;

      dispatch(
        setLastReadMessage({
          chatId,
          lastReadMessage: {
            id: _.get(messageV2Edge, "node.id"),
            cursor: _.get(messageV2Edge, "node.cursor"),
          },
        })
      );
      writeChatConversationsToCache({
        variables: { id: chatId, organizationId },
        chatConversationsData: update(mainData, {
          messagesV2: {
            edges: { $set: newEdges },
            pageInfo: { $set: newPageInfo },
            totalCount: {
              $set: isResendFlow ? previousCount : previousCount + 1,
            },
          },
        }),
      });

      scrollToBottomInChat({ chatId, scrollInNextTick: true });

      // New message sent, remove the chat suggestions
      dispatch(removeAndCancelSuggestionGeneration(chatId));

      const response = await client.mutate({
        mutation: createMessageMutation,
        variables,
      });

      // api is now successful, replace the local message with the response
      const createdMessage = _.get(response, "data.platform.createMessage");

      messageV2Edge = {
        node: createdMessage,
        cursor: createdMessage.cursor,
        __typename: "MessageV2Edge",
      };

      const lastReadMessage = {
        id: _.get(messageV2Edge, "node.id"),
        cursor: _.get(messageV2Edge, "node.cursor"),
      };

      dispatch(setLastReadMessage({ chatId, lastReadMessage }));
      // get the latest data from cache, needed after async call
      mainData = getChatConversationsFromCache({ id: chatId, organizationId });
      edges = _.get(mainData, "messagesV2.edges", []);

      writeChatConversationsToCache({
        variables: { id: chatId, organizationId },
        chatConversationsData: update(mainData, {
          messagesV2: {
            edges: {
              $set: replaceLocalMessage({
                edges,
                newEdge: messageV2Edge,
                localMessageId: newMessageId,
              }),
            },
          },
        }),
      });

      dispatch(
        setMessageStatus({
          messageId: newMessageId,
          status: null, // to clear status and messageId key from redux
        })
      );

      const userId = getUserId(state); // getting current user as this is not used in view mode
      const chatDetailsQueryVariables = getChatDetailsQueryVariables({
        chatId,
        userId,
      });

      const chatDetailsCacheData = getChatDetailsFromCache(
        chatDetailsQueryVariables
      );
      const { type: chatType } = chatDetailsCacheData;
      dispatch(handleNewMessage({ chatId, chatType }));

      return { successful: true };
    } catch (e) {
      dispatch(
        setMessageStatus({
          messageId: newMessageId,
          status: MESSAGE_STATUS.FAILED,
        })
      );
      writeMessageToCache({
        messageId: newMessageId,
        data: newMessage,
        organizationId,
      });

      // Scroll to bottom if the message is last and if near bottom
      const messageElement = document.getElementById(
        getMessageDOMId(newMessage)
      );
      // TODO: change this approach if we decide to use virtualized list
      const isLastMessage = messageElement && !messageElement.nextSibling;
      if (isLastMessage) scrollOnlyIfNearBottom({ chatId });

      if (e.networkError) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:no_internet_connection",
            type: "warning",
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            type: "warning",
          })
        );
      }
      return {
        successful: false,
      };
    }
  };
};

export const updateMessage = params => {
  return async dispatch => {
    const userInfo = getUserInfo();
    const chatId = _.get(params, "chatId", "");
    const messageId = _.get(params, "id", "");
    const label = _.trim(_.get(params, "label", ""));
    const collaborators = _.get(params, "collaborators", []);
    const attachments = _.get(params, "attachments", []);

    dispatch(clearDraft(chatId));

    const { user_type: userType, id: userId } = userInfo;

    const messageData = readMessageFromCache({
      messageId,
      organizationId,
    });

    const attachmentCreatedBy = _.includes(["student", "staff"], userType)
      ? _.capitalize(userType)
      : "FamilyMember";

    const updatedAttachments = _.map(attachments, attachment => {
      return {
        id: generateRandomIdV2(),
        thumbUrl: null,
        title: null,
        streamUrl: null,
        signedUrl: null,
        parentType: "MESSAGE_ITEM",
        createdBy: {
          id: userId,
          type: userType,
          __typename: attachmentCreatedBy,
        },
        interaction: null,
        ...attachment,
        __typename: "Attachment",
      };
    });

    const updatedMessage = {
      ...messageData,
      id: messageId,
      label,
      attachments: updatedAttachments,
      updatedAt: moment().toISOString(),
      __typename: "MessageV2",
    };

    const attachmentsInput = _.map(attachments, attachment => ({
      ..._.omit(attachment, [
        "streamUrl",
        "__typename",
        "signedUrl",
        "interaction",
      ]),
      createdBy: _.get(attachment, "createdBy.id", userId),
    }));

    const taggedUsers = getTaggedUserIds({
      comment: label,
      collaborators,
    });
    const organizationId = getOrganizationId();

    const variables = {
      updateMessageV2Input: {
        id: messageId,
        label: _.trim(label),
        taggedUsers,
        attachments: attachmentsInput,
      },
      organizationId,
    };

    try {
      await client.mutate({
        mutation: updateMessageMutation,
        variables,
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            updateMessage: updatedMessage,
          },
        },
        update: (
          cache,
          {
            data: {
              platform: { updateMessage },
            },
          }
        ) => {
          setTimeout(() => {
            writeMessageToCache({
              messageId,
              data: updateMessage,
              organizationId,
            });
          });
        },
      });

      return { successful: true };
    } catch (e) {
      writeMessageToCache({
        messageId,
        data: messageData,
        organizationId,
      });
      if (e.networkError) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:no_internet_connection",
            type: "warning",
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            type: "warning",
          })
        );
      }
      return {
        successful: false,
      };
    }
  };
};

export const createPollMessage = params => {
  return async (dispatch, getState) => {
    const state = getState();

    const chatId = _.get(params, "chatId");
    const question = _.get(params, "question");
    const submittedOption = _.get(params, "options", []);
    const options = _.filter(submittedOption, option => {
      return !_.isEmpty(_.get(option, "label")) || !_.isEmpty(option.emoji);
    });

    const settings = _.get(params, "settings", {});
    const userInfo = getUserInfo();

    const messageId = _.get(params, "id");
    const newMessageId = messageId || `NEW_${generateRandomIdV2()}`;
    const isResendFlow = !!messageId;

    const organizationId = getOrganizationId();

    dispatch(
      setMessageStatus({
        messageId: newMessageId,
        status: MESSAGE_STATUS.SENDING,
      })
    );

    const { user_type: userType } = userInfo;

    const attachmentCreatedBy = _.includes(["student", "staff"], userType)
      ? _.capitalize(userType)
      : "FamilyMember";

    const expiresAt = _.get(settings, "expiresAt", null);
    const expireAtDate = moment(expiresAt).toISOString();
    const interaction = {
      id: generateRandomIdV2(),
      isResponseActive: true,
      options: _.map(options, option => ({
        id: generateRandomIdV2(),
        label: _.get(option, "label"),
        selectedByUsersCount: 0,
        isSelectedByUser: false,
        metadata: _.pick(option.emoji, ["id", "unified"]),
        __typename: "MessageV2InteractionFieldOption",
      })),
      question,
      expiresAt: expireAtDate,
      ...settings,
      __typename: "MessageV2Poll",
    };

    const newAttachments = [
      {
        id: generateRandomIdV2(),
        name: null,
        type: INTERACTION_TYPE.POLL,
        mimeType: null,
        url: null,
        thumbUrl: null,
        title: null,
        streamUrl: null,
        signedUrl: null,
        metadata: null,
        parentType: "MESSAGE_ITEM",
        interaction,
        createdBy: {
          id: generateRandomIdV2(),
          type: userType,
          __typename: attachmentCreatedBy,
        },
        __typename: "Attachment",
      },
    ];

    const now = moment().toISOString();

    const newMessage = {
      id: newMessageId,
      isRead: false,
      isDeleted: false,
      label: "",
      cursor: null,
      type: MESSAGE_TYPE.INTERACTION,
      attachments: newAttachments,
      isFlagged: false,
      summaryRange: null,
      reactions: [],
      createdBy: {
        ..._.pick(
          getUserBasicDetailsFromCache({
            id: userInfo.id,
            type: userInfo.userEntityType,
          }),
          USER_BASIC_DETAILS_PICK_KEYS
        ),
        // only active user can send message anyways
        isArchived: false,
        isDeleted: false,
        type: userType,
      },
      createdAt: now,
      updatedAt: now,
      parentMessage: null,
      channelActivity: null,
      __typename: "MessageV2",
    };

    try {
      let mainData = getChatConversationsFromCache({
        id: chatId,
        organizationId,
      });

      if (isResendFlow) {
        const messagesNode = _.get(mainData, "messagesV2.edges", []);
        const failedMessageIndex = _.findIndex(messagesNode, messageNode =>
          isIdEqual(newMessageId, _.get(messageNode, "node.id"))
        );
        if (failedMessageIndex !== -1) {
          mainData = update(mainData, {
            messagesV2: {
              edges: { $splice: [[failedMessageIndex, 1]] },
            },
          });
        }
      }
      // add the new local message optimistically
      let edges = _.get(mainData, "messagesV2.edges", []);
      const pageInfo = _.get(mainData, "messagesV2.pageInfo", {});
      const previousCount = _.get(mainData, "messagesV2.totalCount", 0);
      const hasNextPage = _.get(
        mainData,
        "messagesV2.pageInfo.hasNextPage",
        false
      );
      let messageV2Edge = {
        cursor: null,
        node: newMessage,
        __typename: "MessageV2Edge",
      };
      // reset all the server messages if hasNextPage is true
      // and show only the local(in progress) messages, by appending this new one
      // and call fetchOldMessages in the component.
      const edgesToPreserve = hasNextPage
        ? _.filter(edges, edge => getIsLocalMessage(_.get(edge, "node.id")))
        : edges;
      const newEdges = [messageV2Edge, ...edgesToPreserve];
      const newPageInfo = hasNextPage
        ? {
            ...pageInfo,
            hasPreviousPage: true,
            hasNextPage: false,
            startCursor: null,
            endCursor: null,
          }
        : pageInfo;
      dispatch(
        setLastReadMessage({
          chatId,
          lastReadMessage: {
            id: _.get(messageV2Edge, "node.id"),
            cursor: _.get(messageV2Edge, "node.cursor"),
          },
        })
      );
      writeChatConversationsToCache({
        variables: { id: chatId, organizationId },
        chatConversationsData: update(mainData, {
          messagesV2: {
            edges: { $set: newEdges },
            pageInfo: { $set: newPageInfo },
            totalCount: {
              $set: isResendFlow ? previousCount : previousCount + 1,
            },
          },
        }),
      });
      scrollToBottomInChat({ chatId, scrollInNextTick: true });
      // New message sent, remove the chat suggestions
      dispatch(removeAndCancelSuggestionGeneration(chatId));

      const response = await client.mutate({
        mutation: createPollMessageMutation,
        variables: {
          organizationId,
          input: {
            chatId,
            question,
            options: _.map(options, option => ({
              label: _.get(option, "label"),
              type: "OPTION",
              metadata: _.pick(option.emoji, ["id", "unified"]),
            })),
            ...(settings || {}),
            expiresAt: expireAtDate,
          },
          interactionMessageInput: {
            chatIds: [chatId],
            first: 1,
          },
        },
      });

      // api is now successful, replace the local message with the response
      const createdMessage = _.get(
        response,
        "data.platform.createMessageV2Poll.messages.edges[0].node"
      );

      messageV2Edge = {
        node: createdMessage,
        cursor: createdMessage.cursor,
        __typename: "MessageV2Edge",
      };
      const lastReadMessage = {
        id: _.get(messageV2Edge, "node.id"),
        cursor: _.get(messageV2Edge, "node.cursor"),
      };
      dispatch(setLastReadMessage({ chatId, lastReadMessage }));
      // get the latest data from cache, needed after async call
      mainData = getChatConversationsFromCache({ id: chatId, organizationId });
      edges = _.get(mainData, "messagesV2.edges", []);
      writeChatConversationsToCache({
        variables: { id: chatId, organizationId },
        chatConversationsData: update(mainData, {
          messagesV2: {
            edges: {
              $set: replaceLocalMessage({
                edges,
                newEdge: messageV2Edge,
                localMessageId: newMessageId,
              }),
            },
          },
        }),
      });
      dispatch(
        setMessageStatus({
          messageId: newMessageId,
          status: null, // to clear status and messageId key from redux
        })
      );
      const userId = getUserId(state); // getting current user as this is not used in view mode
      const chatDetailsQueryVariables = getChatDetailsQueryVariables({
        chatId,
        userId,
      });
      const chatDetailsCacheData = getChatDetailsFromCache(
        chatDetailsQueryVariables
      );
      const { type: chatType } = chatDetailsCacheData;
      dispatch(handleNewMessage({ chatId, chatType }));
      return { successful: true };
    } catch (e) {
      dispatch(
        setMessageStatus({
          messageId: newMessageId,
          status: MESSAGE_STATUS.FAILED,
        })
      );
      writeMessageToCache({
        messageId: newMessageId,
        data: newMessage,
        organizationId,
      });

      // Scroll to bottom if the message is last and if near bottom
      const messageElement = document.getElementById(
        getMessageDOMId(newMessage)
      );
      // TODO: change this approach if we decide to use virtualized list
      const isLastMessage = messageElement && !messageElement.nextSibling;
      if (isLastMessage) scrollOnlyIfNearBottom({ chatId });

      if (e.networkError) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:no_internet_connection",
            type: "warning",
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            type: "warning",
          })
        );
      }
    }
  };
};

export const updatePollSetting = params => {
  return async (dispatch, getState) => {
    const pollId = _.get(params, "pollId");
    const messageId = _.get(params, "messageId", "");
    const settings = _.get(params, "settings", {});

    try {
      const organizationId = getOrganizationId();
      const message = readMessageFromCache({
        messageId,
        organizationId,
      });
      const updatedMessage = update(message, {
        attachments: {
          0: {
            interaction: {
              isResultPublic: {
                $set: _.get(settings, "isResultPublic", true),
              },
              isResponseEditAllowed: {
                $set: _.get(settings, "isResponseEditAllowed", false),
              },
              expiresAt: { $set: _.get(settings, "expiresAt", null) },
              isMultipleVoteAllowed: {
                $set: _.get(settings, "isMultipleVoteAllowed", false),
              },
            },
          },
        },
      });
      writeMessageToCache({
        messageId,
        data: updatedMessage,
        organizationId,
      });

      // Update the interaction settings
      await client.mutate({
        mutation: updateInteractionSettingsMutation,
        variables: {
          input: {
            interactionId: pollId,
            ...settings,
          },
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:setting_updated_successfully",
          type: "success",
        })
      );
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const createPollResponse = params => {
  return async dispatch => {
    const messageId = _.get(params, "messageId");
    const optionId = _.get(params, "optionId", []);
    const organizationId = getOrganizationId();

    const message = readMessageFromCache({
      messageId,
      organizationId,
    });

    try {
      const attachments = _.get(message, "attachments", []);
      const firstAttachment = _.first(attachments);

      const interaction = _.get(firstAttachment, "interaction", {});

      const pollId = _.get(interaction, "id", "");

      const isMultipleVoteAllowed = _.get(
        interaction,
        "isMultipleVoteAllowed",
        false
      );

      const options = _.get(interaction, "options", []);

      const selectedIndex = _.findIndex(options, { id: optionId });

      if (selectedIndex === -1) return;
      let updatedMessage;

      if (isMultipleVoteAllowed) {
        const wasSelected = _.get(
          options[selectedIndex],
          "isSelectedByUser",
          false
        );
        const currentCount = _.get(
          options[selectedIndex],
          "selectedByUsersCount",
          0
        );

        updatedMessage = update(message, {
          attachments: {
            0: {
              interaction: {
                options: {
                  [selectedIndex]: {
                    isSelectedByUser: { $set: !wasSelected },
                    selectedByUsersCount: {
                      $set: wasSelected
                        ? Math.max(0, currentCount - 1)
                        : currentCount + 1,
                    },
                  },
                },
              },
            },
          },
        });
      } else {
        const previouslySelectedIndex = _.findIndex(options, {
          isSelectedByUser: true,
        });

        const mergedUpdates = {};
        const selectedOption = options[selectedIndex];
        const isCurrentlySelected = _.get(
          selectedOption,
          "isSelectedByUser",
          false
        );

        // If the user clicks on an already selected option, deselect it
        if (previouslySelectedIndex === selectedIndex && isCurrentlySelected) {
          const currentCount = _.get(selectedOption, "selectedByUsersCount", 0);
          mergedUpdates[selectedIndex] = {
            isSelectedByUser: { $set: false },
            selectedByUsersCount: { $set: Math.max(0, currentCount - 1) },
          };
        } else {
          // Deselect previously selected option if different from current
          if (
            previouslySelectedIndex !== -1 &&
            previouslySelectedIndex !== selectedIndex
          ) {
            const prevCount = _.get(
              options[previouslySelectedIndex],
              "selectedByUsersCount",
              0
            );
            mergedUpdates[previouslySelectedIndex] = {
              isSelectedByUser: { $set: false },
              selectedByUsersCount: { $set: Math.max(0, prevCount - 1) },
            };
          }

          // Select the new option
          const selectedCount = _.get(
            selectedOption,
            "selectedByUsersCount",
            0
          );
          mergedUpdates[selectedIndex] = {
            isSelectedByUser: { $set: true },
            selectedByUsersCount: {
              $set: selectedCount + (isCurrentlySelected ? 0 : 1),
            },
          };
        }

        updatedMessage = update(message, {
          attachments: {
            0: {
              interaction: {
                options: mergedUpdates,
              },
            },
          },
        });
      }

      writeMessageToCache({
        messageId,
        data: updatedMessage,
        organizationId,
      });

      const updatedOptions = _.get(
        updatedMessage,
        "attachments[0].interaction.options",
        []
      );

      const selectedOptionIds = _.chain(updatedOptions)
        .filter({ isSelectedByUser: true })
        .map("id")
        .value();

      await client.mutate({
        mutation: createPollResponseMutation,
        variables: {
          input: {
            pollId,
            selectedOptionIds,
          },
        },
      });
    } catch (e) {
      writeMessageToCache({
        messageId,
        data: message,
        organizationId,
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const handlePollExpired = params => {
  return async (dispatch, getState) => {
    const messageId = _.get(params, "messageId");
    const organizationId = getOrganizationId();

    const message = readMessageFromCache({
      messageId,
      organizationId,
    });

    try {
      const updatedMessage = update(message, {
        attachments: {
          0: {
            interaction: {
              isResponseActive: { $set: false },
            },
          },
        },
      });

      writeMessageToCache({
        messageId,
        data: updatedMessage,
        organizationId,
      });
    } catch (e) {
      writeMessageToCache({
        messageId,
        data: message,
        organizationId,
      });
    }
  };
};

export const forwardMessage = ({
  message,
  selectedEntity,
  customMessage,
  selectedChatId,
  selectedSection,
  selectedChannelTypes,
  selectedUserTypes,
  firstEntityName = "",
}) => {
  return async dispatch => {
    const messageId = _.get(message, "id", "");
    const organizationId = getOrganizationId();

    const channelsIds = [..._.get(selectedEntity, "CHANNELS", [])];
    const userIds = [..._.get(selectedEntity, "USERS", [])];

    const totalEntities = _.size(channelsIds) + _.size(userIds);

    const localeChannelsWithNewSuffix = _.filter(channelsIds, id =>
      getIsLocalMessage(id)
    );
    const familyChannels = _.map(localeChannelsWithNewSuffix, ids =>
      _.last(_.split(ids, "NEW_"))
    );
    const chatIds = _.filter(channelsIds, id => !getIsLocalMessage(id));

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId: selectedChatId,
      userId: getUserId(),
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    const chatUser = _.get(chatDetailsCacheData, "personalChatReceiverUser.id");

    const input = {
      chatIds,
      userIds,
      studentIdsForFamilyChannel: familyChannels,
      messageId,
      label: customMessage,
    };

    const queryVariables = _.isEqual(selectedSection, CHAT_TYPE.CHAT)
      ? getChatListQueryVariables({ userType: selectedUserTypes })
      : getChannelListQueryVariables({ channelTypes: selectedChannelTypes });

    const cacheChatData = getChatConversationsFromCache({
      id: selectedChatId,
      organizationId,
    });

    const mainData = _.get(cacheChatData, "messagesV2.edges", []);

    const lastMessage = _.find(
      mainData,
      messageNode => !getIsLocalMessage(_.get(messageNode, "node.id"))
    );

    let lastCursor = _.get(lastMessage, "node.cursor", "");

    if (!lastCursor) {
      const filteredMessages = _.filter(
        mainData,
        messageNode => !getIsLocalMessage(_.get(messageNode, "node.id"))
      );

      // if no cursor found, and no messages present, meaning received first message
      // so set the cursor to null, to fetch latest messages
      if (_.isEmpty(filteredMessages)) {
        lastCursor = null;
      }
    }

    const isForwardedMessageIdIncludeCurrentScreen =
      _.includes(chatIds, selectedChatId) || _.includes(userIds, chatUser);

    const refetchQueries = isMessagingRevampV2Enabled()
      ? [
          {
            query: getChatAndChannelListQuery,
            variables: getChatAndChannelListQueryVariables(),
          },
        ]
      : _.isEqual(selectedSection, CHAT_TYPE.CHAT)
      ? [
          {
            query: getChatListQuery,
            variables: queryVariables,
          },
        ]
      : [
          {
            query: getChannelListQuery,
            variables: queryVariables,
          },
        ];

    try {
      await client.mutate({
        mutation: forwardMessageMutation,
        variables: {
          input,
        },

        awaitRefetchQueries: true,
        refetchQueries,
      });

      if (isForwardedMessageIdIncludeCurrentScreen) {
        const result = await client.query({
          query: getChatConversationsQuery,
          variables: {
            id: selectedChatId,
            organizationId,
            input: {
              first: PAGINATION_LIMITS.FETCH_MORE_MESSAGES,
              before: lastCursor,
              excludeOtherUserMessageType: [MESSAGE_TYPE.CONVERSATION_SUMMARY],
            },
            portalType: "PLANNER",
          },
        });

        const newDataEdges = _.get(result, "data.node.messagesV2.edges", []);

        const newMessages = lastCursor
          ? _.reverse(_.clone(newDataEdges))
          : newDataEdges;

        // Similarly when the cursor used for query was null, we got the latest messages
        // so hasNextPage and nextEndCursor is false and null respectively
        const newMessageHaNextMore = lastCursor
          ? _.get(result, "data.node.messagesV2.pageInfo.hasNextPage", false)
          : false;

        const newEndCursor = lastCursor
          ? _.get(result, "data.node.messagesV2.pageInfo.endCursor", null)
          : null;

        const totalCount = _.get(result, "data.node.messagesV2.totalCount", 0);

        const dataToSend = update(cacheChatData, {
          messagesV2: {
            edges: { $unshift: newMessages },
            pageInfo: {
              $merge: {
                hasNextPage: newMessageHaNextMore,
                endCursor: newEndCursor,
              },
            },
            totalCount: {
              $set: totalCount,
            },
          },
        });

        writeChatConversationsToCache({
          variables: { id: selectedChatId, organizationId },
          chatConversationsData: dataToSend,
        });
      }

      dispatch(
        setToastMsg({
          msg: _.gt(totalEntities, 1)
            ? "toastMsgs:message_forwarded_to_label_count"
            : "toastMsgs:message_forwarded_to_label",
          locale_params: [
            {
              key: "label",
              value: firstEntityName,
              isPlainText: true,
            },
            {
              key: "count",
              value: totalEntities - 1,
              isPlainText: true,
            },
          ],

          type: "success",
        })
      );
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

export const forwardInteractiveMessage = ({
  channelIds,
  interactionId,
  firstEntityName,
}) => {
  return async dispatch => {
    try {
      const { chatIds, studentIdsForFamilyChannel } = _.reduce(
        channelIds,
        (result, channelId) => {
          if (getIsLocalMessage(channelId)) {
            const studentId = _.last(_.split(channelId, "NEW_"));
            result.studentIdsForFamilyChannel.push(studentId);
          } else {
            result.chatIds.push(channelId);
          }
          return result;
        },
        { chatIds: [], studentIdsForFamilyChannel: [] }
      );

      await client.mutate({
        mutation: forwardInteractionMutation,
        variables: {
          input: {
            chatIds,
            studentIdsForFamilyChannel,
            interactionId,
          },
        },
        refetchQueries: [
          {
            query: getChatAndChannelListQuery,
            variables: getChatAndChannelListQueryVariables(),
          },
        ],
      });

      dispatch(
        setToastMsg({
          msg: _.gt(_.size(channelIds), 1)
            ? "toastMsgs:message_forwarded_to_label_count"
            : "toastMsgs:message_forwarded_to_label",
          locale_params: [
            {
              key: "label",
              value: firstEntityName,
              isPlainText: true,
            },
            {
              key: "count",
              value: _.size(channelIds) - 1,
              isPlainText: true,
            },
          ],

          type: "success",
        })
      );
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
  };
};

const isDraftStateEmpty = draft => {
  const { label, attachments, parentMessage } = draft;
  const isLabelEmpty = _.isEmpty(_.trim(label));
  const isAttachmentsEmpty = _.isEmpty(attachments);
  const isParentEmpty = _.isEmpty(parentMessage);
  return isLabelEmpty && isAttachmentsEmpty && isParentEmpty;
};

// messageId is optional
export const handleMessagesChanges = ({
  chatId,
  messageId,
  count = PAGINATION_LIMITS.FETCH_MORE_MESSAGES,
}) => {
  return async dispatch => {
    const organizationId = getOrganizationId();

    if (!chatId) return;

    let mainData = getChatConversationsFromCache({
      id: chatId,
      organizationId,
    });

    // messaging cache not available then do nothing
    if (_.isEmpty(mainData)) return;
    const mainMessages = _.get(mainData, "messagesV2.edges", []);

    try {
      const isOptimisticAblyCallEnabled = isConnectOptimisticAblyCallEnabled();
      const isOpenedChat = !!getChatContainer(chatId);

      const isUserNearBottom = isChatNearBottom({ chatId });
      if (isOptimisticAblyCallEnabled && isOpenedChat && isUserNearBottom) {
        markConversationAsRead({ chatId });
      }

      // check if message id already exists in cache update the field to do update and delete
      // update message
      const messageData = readMessageFromCache({
        messageId,
        organizationId,
      });

      // TODO: confirm for suggestion invalidation on message update/delete
      if (!_.isEmpty(messageData)) {
        await client.query({
          query: getMessageQuery,
          variables: {
            id: messageId,
            organizationId,
            portalType: "PLANNER",
          },
          fetchPolicy: "network-only",
        });
        return;
      }

      const hasNextPage = _.get(
        mainData,
        "messagesV2.pageInfo.hasNextPage",
        false
      );

      if (hasNextPage) {
        const unreadState = await client.query({
          query: getLatestUnreadStateQuery,
          variables: { id: chatId, portalType: "PLANNER" },
        });

        mainData = getChatConversationsFromCache({
          id: chatId,
          organizationId,
        });

        const unreadMessageCount = _.get(mainData, "unreadMessageCount", 0);

        const lastReadMessage = _.get(
          unreadState,
          "data.node.lastReadMessage",
          {}
        );

        if (unreadMessageCount) dispatch(setShowUnreadMessageButton(true));
        dispatch(
          setLastReadMessage({
            chatId,
            lastReadMessage,
          })
        );

        // remove chat suggestions on new message receive even when hasNextPage is true
        if (messageId) dispatch(removeAndCancelSuggestionGeneration(chatId));

        return; // do nothing if paginated data not fetched completely
      }

      const lastMessage = _.find(
        mainMessages,
        messageNode => !getIsLocalMessage(_.get(messageNode, "node.id"))
      );

      let lastCursor = _.get(lastMessage, "node.cursor", "");

      if (!lastCursor) {
        const filteredMessages = _.filter(
          mainMessages,
          messageNode => !getIsLocalMessage(_.get(messageNode, "node.id"))
        );

        // if no cursor found, and no messages present, meaning received first message
        // so set the cursor to null, to fetch latest messages
        if (_.isEmpty(filteredMessages)) {
          lastCursor = null;
        } else return;
      }

      const newDataPromise = client.query({
        query: getChatConversationsQuery,
        variables: {
          id: chatId,
          organizationId,
          input: {
            first: count,
            before: lastCursor,
            excludeOtherUserMessageType: [MESSAGE_TYPE.CONVERSATION_SUMMARY],
          },
          portalType: "PLANNER",
        },
        context: { useHttpLink: true },
        fetchPolicy: "no-cache",
      });

      const latestUnreadPromise = client.query({
        query: getLatestUnreadStateQuery,
        variables: { id: chatId, portalType: "PLANNER" },
      });

      // same as Promise.all()
      const newData = await newDataPromise;
      const unreadState = await latestUnreadPromise;

      const newDataEdges = _.get(newData, "data.node.messagesV2.edges", []);

      mainData = getChatConversationsFromCache({
        id: chatId,
        organizationId,
      });

      const filteredEdges = _.filter(newDataEdges, messageEdge => {
        const messageId = _.get(messageEdge, "node.id");

        const messageData = readMessageFromCache({
          messageId,
          organizationId,
        });
        return _.isEmpty(messageData);
      });

      if (_.isEmpty(filteredEdges)) {
        return; // all data already added in cache
      }

      // received new message, remove the chat suggestions
      if (messageId) dispatch(removeAndCancelSuggestionGeneration(chatId));

      // In case when lastCursor is null, meaning first time data is fetched
      // we do not need to reverse the data, as it is returned in desc order
      // from backend, which we want to maintain in cache
      const newMessages = lastCursor
        ? _.reverse(_.clone(filteredEdges))
        : filteredEdges;

      // Similarly when the cursor used for query was null, we got the latest messages
      // so hasNextPage and nextEndCursor is false and null respectively
      const newMessageHaNextMore = lastCursor
        ? _.get(newData, "data.node.messagesV2.pageInfo.hasNextPage", false)
        : false;

      const newEndCursor = lastCursor
        ? _.get(newData, "data.node.messagesV2.pageInfo.endCursor", null)
        : null;

      const totalCount = _.get(newData, "data.node.messagesV2.totalCount", 0);
      const lastReadMessage = _.get(
        unreadState,
        "data.node.lastReadMessage",
        {}
      );
      // TODO: keep the sending messages at the latest position, and
      // append new received messages before them
      const dataToSend = update(mainData, {
        messagesV2: {
          edges: { $unshift: newMessages },
          pageInfo: {
            $merge: {
              hasNextPage: newMessageHaNextMore,
              endCursor: newEndCursor,
            },
          },
          totalCount: {
            $set: totalCount,
          },
        },
      });

      if (!isOpenedChat) {
        writeChatConversationsToCache({
          variables: { id: chatId, organizationId },
          chatConversationsData: dataToSend,
        });
      } else {
        // write to cache after scroll calculation and before scroll
        scrollOnlyIfNearBottom({
          chatId,
          behavior: "instant",
          afterCalculationCb: isNearBottom => {
            writeChatConversationsToCache({
              variables: { id: chatId, organizationId },
              chatConversationsData: dataToSend,
            });

            const updateLastReadPointer =
              !isNearBottom &&
              _.isEqual(
                _.get(newData, "data.node.unreadMessageCount", 0),
                _.size(newMessages)
              );

            if (isNearBottom || updateLastReadPointer) {
              // if we actually see the new message in opened chat, then only mark as read
              // this helps in rendering unread-message line in chat list correctly
              if (isNearBottom) {
                if (!isOptimisticAblyCallEnabled) {
                  markConversationAsRead({ chatId });
                } else {
                  resetUnreadMessageCountInCache({ chatId });
                }
              } else {
                dispatch(setShowUnreadMessageButton(true));
                // to enable showing summaries with new messages with red line
                dispatch(setShowSummariesNewMessagesWithAi(true));
              }
              // update last read message in redux

              const finalLastReadMessage = updateLastReadPointer
                ? lastReadMessage
                : {
                    id: _.get(_.first(newMessages), "node.id"),
                    cursor: _.get(_.first(newMessages), "node.cursor"),
                  };

              dispatch(
                setLastReadMessage({
                  chatId,
                  lastReadMessage: finalLastReadMessage,
                })
              );
            }
          },
        });
      }
    } catch (e) {
      // TODO: handle rare case, when query failed and user didn't initiate cache-and-network
      // as user didn't changed the screens. Right now handled with next new notification
    }
  };
};

// A simple store to keep track of cancel functions for summary generation
const SUMMARY_GENERATION_CANCEL_FUNCTIONS = new Map();

const removeSummaryGenerationCancelFunction = chatId => {
  SUMMARY_GENERATION_CANCEL_FUNCTIONS.delete(chatId);
};

export const cancelSummaryGeneration = chatId => {
  const cancelFunc = SUMMARY_GENERATION_CANCEL_FUNCTIONS.get(chatId);
  if (_.isFunction(cancelFunc)) {
    cancelFunc();
    removeSummaryGenerationCancelFunction(chatId);
  }
};

const addSummaryGenerationCancelFunction = ({ chatId, cancelFunc }) => {
  // Although at a time only one summary generation can be there
  // but still cancel the previous one, if any
  cancelSummaryGeneration({ chatId });
  SUMMARY_GENERATION_CANCEL_FUNCTIONS.set(chatId, cancelFunc);
};

const debugModePropsMapForSummary = new Map();
export const getDebugPropsForSummaryMessage = messageId =>
  debugModePropsMapForSummary.get(messageId);

export const removeDebugPropsForSummaryMessage = messageId =>
  debugModePropsMapForSummary.delete(messageId);

export const generateSummary = ({ chatId, after, before }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const organizationId = getOrganizationId();
    const { user_type: userType } = userInfo;

    const input = {
      ...AI_MESSAGING_FIELD_AND_ACTION[MESSAGING_AI_ACTIONS.SUMMARISE],
      metadata: { chatId: [chatId], after, before },
      entityId: chatId,
      curriculumProgramId: getSelectedCurriculumId(state),
    };

    const now = moment().format();
    const newMessageId = `NEW_${generateRandomIdV2()}`;

    const newMessage = {
      id: newMessageId,
      label: "", // Will be injected by AI
      isRead: false,
      isDeleted: false,
      cursor: null,
      type: MESSAGE_TYPE.CONVERSATION_SUMMARY,
      attachments: null,
      reactions: null,
      isFlagged: false,
      summaryRange: {
        start: after,
        end: before,
        __typename: "MessageV2SummaryRange",
      },
      createdBy: {
        ..._.pick(
          getUserBasicDetailsFromCache({
            id: userInfo.id,
            type: userInfo.userEntityType,
          }),
          USER_BASIC_DETAILS_PICK_KEYS
        ),
        // only active user can send message anyways
        isArchived: false,
        isDeleted: false,
        type: userType,
      },
      createdAt: now,
      updatedAt: now,
      parentMessage: null,
      channelActivity: null,
      __typename: "MessageV2",
    };

    // this adds the generating loader state
    dispatch(
      setSummaryGenerationStatus({ messageId: newMessageId, status: true })
    );

    // This creates an empty label message and append in chat list
    // to show generating loader and stop button
    const messageEdge = {
      cursor: null,
      node: newMessage,
      __typename: "MessageV2Edge",
    };

    let mainData = getChatConversationsFromCache({
      id: chatId,
      organizationId,
    });

    const pageInfo = _.get(mainData, "messagesV2.pageInfo", {
      __typename: "PageInfo",
      hasNextPage: false,
    });
    const { hasNextPage } = pageInfo;

    dispatch(
      setMessageStatus({
        messageId: newMessageId,
        status: MESSAGE_STATUS.SENDING,
      })
    );

    // reset all the server messages if hasNextPage is true
    // and show only the local(in progress) messages, by appending this new one
    // and call fetchOldMessages in the component.
    const newPageInfo = hasNextPage
      ? {
          ...pageInfo,
          hasPreviousPage: true,
          hasNextPage: false,
          startCursor: null,
          endCursor: null,
        }
      : pageInfo;

    writeChatConversationsToCache({
      variables: { id: chatId, organizationId },
      chatConversationsData: update(mainData, {
        messagesV2: {
          pageInfo: { $set: newPageInfo },
          // if hasNextPage is true, reset all the cache messages(will be fetched again in component)
          edges: hasNextPage
            ? { $set: [messageEdge] }
            : { $unshift: [messageEdge] },
        },
      }),
    });

    scrollToBottomInChat({ chatId, scrollInNextTick: true });

    const isAIDebugModeEnabled = getIsAIDebugModeEnabled();

    await dispatch(
      getAIResponse({
        variables: { input },
        getCancelToken: cancelTokenFunc => {
          addSummaryGenerationCancelFunction({
            chatId,
            cancelFunc: cancelTokenFunc,
          });
        },
        onDownloadProgress: parsedResponse => {
          const {
            content,
            usageMetricsId,
            intentUsageMetricsId,
            model,
            temperature,
          } = parsedResponse;

          if (isAIDebugModeEnabled) {
            const debugModeProps = {
              usageMetricsId,
              intentUsageMetricsId,
              model,
              temperature,
            };
            debugModePropsMapForSummary.set(newMessageId, debugModeProps);
          }

          const cachedMessage = readMessageFromCache({
            messageId: newMessageId,
            organizationId,
          });

          const messageToSave = { ...cachedMessage, label: content };
          writeMessageToCache({
            messageId: newMessageId,
            data: messageToSave,
            organizationId,
          });
          // NOTE: scroll to bottom on update of message content
          // is handled directly in the component.(for better control)
        },
        onError: () => {
          // TODO: maybe show toast and remove the
          // optimistically added empty summary message
        },
      })
    );

    removeSummaryGenerationCancelFunction(chatId);
    dispatch(
      setSummaryGenerationStatus({ messageId: newMessageId, status: false })
    );

    // Save the summary message on backend
    try {
      const cachedMessage = readMessageFromCache({
        messageId: newMessageId,
        organizationId,
      });
      if (!_.trim(cachedMessage.label)) return;

      const variables = {
        input: {
          chatId,
          label: cachedMessage.label,
          type: MESSAGE_TYPE.CONVERSATION_SUMMARY,
          before,
          after,
        },
        organizationId,
      };

      const response = await client.mutate({
        mutation: createConversationSummaryMutation,
        variables,
      });

      // api is now successful, replace the local message with the response
      const createdMessage = _.get(
        response,
        "data.platform.createConversationSummary"
      );

      const messageV2Edge = {
        node: createdMessage,
        cursor: createdMessage.cursor,
        __typename: "MessageV2Edge",
      };

      // get the latest data from cache, needed after async call
      mainData = getChatConversationsFromCache({ id: chatId, organizationId });
      const edges = _.get(mainData, "messagesV2.edges", []);

      if (isAIDebugModeEnabled) {
        // Add debug props for saved summary message
        const debugModeProps = getDebugPropsForSummaryMessage(newMessageId);
        debugModePropsMapForSummary.set(createdMessage.id, debugModeProps);
      }

      writeChatConversationsToCache({
        variables: { id: chatId, organizationId },
        chatConversationsData: update(mainData, {
          messagesV2: {
            edges: {
              $set: replaceLocalMessage({
                edges,
                newEdge: messageV2Edge,
                localMessageId: newMessageId,
              }),
            },
          },
        }),
      });

      if (isAIDebugModeEnabled) {
        // Remove debug props for local summary message, which is now
        // overwritten by the saved summary message
        removeDebugPropsForSummaryMessage(newMessageId);
      }

      dispatch(
        setMessageStatus({
          messageId: newMessageId,
          status: null, // to clear status and messageId key from redux
        })
      );

      const state = getState();
      const userId = getUserId(state); // getting current user as this is not used in view mode
      const chatDetailsQueryVariables = getChatDetailsQueryVariables({
        chatId,
        userId,
      });

      const chatDetailsCacheData = getChatDetailsFromCache(
        chatDetailsQueryVariables
      );
      const { type: chatType } = chatDetailsCacheData;
      dispatch(handleNewMessage({ chatId, chatType }));
    } catch (e) {
      dispatch(
        setMessageStatus({
          messageId: newMessageId,
          status: MESSAGE_STATUS.FAILED,
        })
      );

      // Scroll to bottom if the message is last and if near bottom
      const messageElement = document.getElementById(
        getMessageDOMId(newMessage)
      );

      // TODO: change this approach if we decide to use virtualized list
      const isLastMessage = messageElement && !messageElement.nextSibling;
      if (isLastMessage) scrollOnlyIfNearBottom({ chatId });

      if (e.networkError) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:no_internet_connection",
            type: "warning",
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            type: "warning",
          })
        );
      }
    }
  };
};

export const generateSummaryForNewMessages = ({
  chatId,
  previousMessageId,
  messageId,
}) => {
  return async dispatch => {
    let message;

    if (messageId) {
      message = readMessageFromCache({
        messageId,
        organizationId: getOrganizationId(),
      });
    } else if (previousMessageId) {
      const mainData = getChatConversationsFromCache({
        id: chatId,
        organizationId: getOrganizationId(),
      });

      const messagesEdges = _.get(mainData, "messagesV2.edges", []);

      // find message after previousMessageId
      const previousMessageIndex = _.findIndex(messagesEdges, messageNode =>
        isIdEqual(_.get(messageNode, "node.id"), previousMessageId)
      );

      message = _.get(messagesEdges, [previousMessageIndex - 1, "node"]);
    }

    const after = _.get(message, "createdAt");
    const before = moment().format();
    if (chatId && after && before) {
      dispatch(generateSummary({ chatId, after, before }));
    }
  };
};

const JSONParseSafe = str => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return "";
  }
};

const EMPTY_ARR = [];
// if message is sent, received, edited or deleted
export const generateSuggestions = ({ chatId }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const isAIGenerateEnabled = getIsAIGenerateEnabled(state);
    if (!isAIGenerateEnabled) return;

    const messagingReduxState = getMessagingV2ReduxState(state);
    const isAIDebugModeEnabled = getIsAIDebugModeEnabled();
    const { suggestions: prevSuggestions, isLoading } = _.get(
      messagingReduxState,
      ["aiSuggestions", chatId],
      {
        suggestions: [],
      }
    );

    if (isLoading) return;
    // TODO: need to figure out some way to smart cache this
    // if (!_.isEmpty(prevSuggestions)) return;

    dispatch(setSuggestionGenerationRequested({ chatId }));
    let suggestions = EMPTY_ARR;
    try {
      const response = await dispatch(
        getAIResponse({
          variables: {
            input: {
              ...AI_MESSAGING_FIELD_AND_ACTION[
                MESSAGING_AI_ACTIONS.GENERATE_SUGGESTIONS
              ],
              metadata: { chatId: [chatId] },
              entityId: chatId,
              curriculumProgramId: getSelectedCurriculumId(state),
            },
          },
          getCancelToken: cancelTokenFunc => {
            addSuggestionGenerationCancelFunction({
              chatId,
              cancelFunc: cancelTokenFunc,
            });
          },
          onError: () => {
            // TODO: maybe show toast
          },
        })
      );
      const { content } = response;
      suggestions = JSONParseSafe(content);
      if (!_.isArray(suggestions)) suggestions = EMPTY_ARR;

      if (isAIDebugModeEnabled) {
        const {
          usageMetricsId,
          intentUsageMetricsId,
          model,
          temperature,
        } = response;

        const debugModeProps = {
          usageMetricsId,
          intentUsageMetricsId,
          model,
          temperature,
        };
        summaryGenDebugModePropsMap.set(chatId, debugModeProps);
      }

      removeSuggestionGenerationCancelFunction(chatId);
      dispatch(setSuggestionGenerationCompleted({ chatId, suggestions }));
    } catch (err) {
      dispatch(setSuggestionGenerationCompleted({ chatId, suggestions }));
      // TODO: maybe show toast
    }
  };
};

export const cleanUpFailedMessages = ({ chatId }) => {
  return async (dispatch, getState) => {
    const organizationId = getOrganizationId();
    const state = getState();
    const messagingV2State = getMessagingV2ReduxState(state);
    try {
      const mainData = getChatConversationsFromCache({
        id: chatId,
        organizationId,
      });

      if (_.isEmpty(mainData)) return;

      const messagesEdges = _.get(mainData, "messagesV2.edges", []);

      // remove failed message from persisted cache
      // messageStatus in redux exist and id startWith NEW_ means cached failed message which need to remove
      const filteredEdges = _.reject(
        messagesEdges,
        messageNode =>
          _.startsWith(_.get(messageNode, "node.id"), "NEW_") &&
          !_.get(messagingV2State, ["messageStatus", messageNode.id])
      );

      if (_.isEqual(_.size(messagesEdges), _.size(filteredEdges))) {
        return;
      }

      const dataToSend = update(mainData, {
        messagesV2: {
          edges: { $set: filteredEdges },
        },
      });

      writeChatConversationsToCache({
        variables: { id: chatId, organizationId },
        chatConversationsData: dataToSend,
      });

      return dataToSend;
    } catch (e) {
      // do nothing
    }
  };
};

export const refetchChatMessagesDataInCache = async ({ chatId }) => {
  const organizationId = getOrganizationId();

  let queryData = getChatConversationsFromCache({
    id: chatId,
    organizationId,
  });
  const messagesEdges = _.get(queryData, "messagesV2.edges", []);
  const filteredEdges = _.reject(messagesEdges, ({ node }) =>
    getIsLocalMessage(node.id)
  );

  if (_.isEmpty(filteredEdges)) return;

  const latestMessage = _.first(filteredEdges);
  const latestMessageCursor = _.get(latestMessage, "node.cursor");
  if (!latestMessageCursor) return;

  const queryPromises = [];

  queryPromises.push(
    client.query({
      query: getMessageQuery,
      variables: {
        id: _.get(latestMessage, "node.id"),
        organizationId,
        portalType: "PLANNER",
      },
      fetchPolicy: "network-only",
    })
  );

  if (filteredEdges.length > 1) {
    queryPromises.push(
      client.query({
        query: getChatConversationsQuery,
        variables: {
          id: chatId,
          organizationId,
          input: {
            first: Math.max(50, _.size(filteredEdges) - 1),
            after: latestMessageCursor,
            excludeOtherUserMessageType: [MESSAGE_TYPE.CONVERSATION_SUMMARY],
          },
          portalType: "PLANNER",
        },
        fetchPolicy: "network-only",
      })
    );
  }

  try {
    const [latestMessageResponse, olderMessages] = await Promise.all(
      queryPromises
    );

    const latestMessageEdge = {
      __typename: "MessageV2Edge",
      cursor: _.get(latestMessageResponse, "data.node.cursor"),
      node: _.get(latestMessageResponse, "data.node"),
    };

    const olderMessagesEdges = _.get(
      olderMessages,
      "data.node.messagesV2.edges",
      []
    );

    // As we fetched for old messages using latestMessageCursor, so these
    // hasNextPage and endCursor will actually be hasPreviousPage and startCursor
    const { hasNextPage: hasPreviousPage, endCursor: startCursor } = _.get(
      olderMessages,
      "data.node.messagesV2.pageInfo",
      {
        hasNextPage: false,
        endCursor: _.get(
          _.last(olderMessagesEdges),
          "node.cursor",
          latestMessageEdge.cursor // in case of no older messages
        ),
      }
    );

    queryData = getChatConversationsFromCache({
      id: chatId,
      organizationId,
    });

    // find the edge for the latestMessage used and replace it and everything
    // before it with the refreshed data
    const edges = _.get(queryData, "messagesV2.edges", []);
    const latestMessageIndex = _.findIndex(edges, ({ node }) =>
      isIdEqual(node.id, _.get(latestMessage, "node.id"))
    );

    // In case when message is not found, which was originally used to fetch
    // the older messages, then do nothing. As we can't find the correct position
    if (latestMessageIndex === -1) return;

    const newEdges = [
      ..._.slice(edges, 0, latestMessageIndex),
      ...(_.get(latestMessageEdge, "node.isDeleted") &&
      isMessagingRevempEnabled()
        ? []
        : [latestMessageEdge]),
      ...olderMessagesEdges,
    ];

    const newData = update(queryData, {
      messagesV2: {
        edges: { $set: _.uniqBy(newEdges, "node.id") },
        pageInfo: {
          $merge: {
            hasPreviousPage,
            startCursor,
          },
        },
      },
    });

    writeChatConversationsToCache({
      variables: { id: chatId, organizationId },
      chatConversationsData: newData,
    });
  } catch (e) {
    // fail silently
  }
};

const updateChannelMessagesReadState = ({ chatId }) => {
  const organizationId = getOrganizationId();

  const mainData = getChatConversationsFromCache({
    id: chatId,
    organizationId,
  });
  const messagesEdges = _.get(mainData, "messagesV2.edges", []);

  if (_.isEmpty(messagesEdges)) {
    // will never happen
    return;
  }

  const unreadMessagesEdges = _.filter(
    messagesEdges,
    ({ node }) => node.isRead === false && !_.startsWith(node.id, "NEW_")
  );

  const oldestUnreadMessage = _.last(unreadMessagesEdges);
  const latestMessage = _.first(unreadMessagesEdges);

  const oldestUnreadMessageCursor = _.get(oldestUnreadMessage, "node.cursor");
  const latestMessageCursor = _.get(latestMessage, "node.cursor");

  const queryPromises = [];

  if (oldestUnreadMessageCursor) {
    queryPromises.push(
      client.query({
        query: getMessageReadStateQuery,
        variables: {
          id: _.get(oldestUnreadMessage, "node.id"),
          portalType: "PLANNER",
        },
        fetchPolicy: "network-only",
      })
    );
  }

  if (!_.isEqual(oldestUnreadMessageCursor, latestMessageCursor)) {
    queryPromises.push(
      client.query({
        query: getMessageReadStateQuery,
        variables: {
          id: _.get(latestMessage, "node.id"),
          portalType: "PLANNER",
        },
        fetchPolicy: "network-only",
      })
    );
  }

  if (_.size(unreadMessagesEdges) >= 3) {
    queryPromises.push(
      client.query({
        query: getChatMessagesReadStateQuery,
        variables: {
          id: chatId,
          portalType: "PLANNER",
          messageFeedInput: {
            before: latestMessageCursor,
            after: oldestUnreadMessageCursor,
            excludeOtherUserMessageType: [MESSAGE_TYPE.CONVERSATION_SUMMARY],
          },
        },
        fetchPolicy: "network-only",
      })
    );
  }

  try {
    Promise.all(queryPromises);
  } catch (e) {
    // do nothing wait for next notification
  }
};

const updatePersonalChatReadState = ({ chatId }) => {
  const organizationId = getOrganizationId();
  const mainData = getChatConversationsFromCache({
    id: chatId,
    organizationId,
  });

  const dataToSend = update(mainData, {
    messagesV2: {
      edges: {
        $apply: edges =>
          _.map(edges, edge => {
            const node = _.get(edge, "node", {});
            return {
              ...edge,
              node: {
                ...node,
                isRead: true,
              },
            };
          }),
      },
    },
  });

  writeChatConversationsToCache({
    variables: { id: chatId, organizationId },
    chatConversationsData: dataToSend,
  });
};

export const handleMessageReadV2 = ({ chatId, maxMessageId }) => {
  const userId = getUserId();
  const organizationId = getOrganizationId();

  const mainData = getChatConversationsFromCache({
    id: chatId,
    organizationId,
  });

  //chat edges present in the cache
  //if not present that means user has loaded that chat and when user load the chat any way latest data will be fetch from network
  if (!_.isNil(mainData)) {
    const messagesEdges = _.get(mainData, "messagesV2.edges", []);
    const updatedEdges = _.reduce(
      messagesEdges,
      (acc, edge) => {
        const node = _.get(edge, "node");

        //eslint-disable-next-line no-undef
        if (BigInt(node.id) <= BigInt(maxMessageId)) {
          return [...acc, { ...edge, node: { ...node, isRead: true } }];
        }
        return [...acc, edge];
      },
      []
    );

    const updatedData = update(mainData, {
      messagesV2: {
        edges: { $set: updatedEdges },
      },
    });
    writeChatConversationsToCache({
      variables: { id: chatId, organizationId },
      chatConversationsData: updatedData,
    });
  }
};

const debouncedUpdateChannelMessagesReadStateByChatId = new Map();

const getDebouncedChannelMessagesReadUpdater = chatId => {
  if (!debouncedUpdateChannelMessagesReadStateByChatId.has(chatId)) {
    debouncedUpdateChannelMessagesReadStateByChatId.set(
      chatId,
      _.debounce(() => updateChannelMessagesReadState({ chatId }), 1000)
    );
  }

  return debouncedUpdateChannelMessagesReadStateByChatId.get(chatId);
};

export const handleMessagesRead = ({ chatId }) => {
  const userId = getUserId(); // getting current user as this is not used in view mode

  try {
    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId,
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    if (_.isEmpty(chatDetailsCacheData)) {
      // no details present in cache, so no need to update
      return;
    }

    const { type: chatType } = chatDetailsCacheData;

    if (chatType === CHAT_TYPE_BE.CHAT_PERSONAL) {
      updatePersonalChatReadState({ chatId });
    } else {
      const debouncedUpdater = getDebouncedChannelMessagesReadUpdater(chatId);
      debouncedUpdater();
    }
  } catch (error) {
    // do nothing wait for next notification
  }
};

export const markMessageAsReadV3 = async ({ chatId }) => {
  try {
    const organizationId = getOrganizationId();
    const mainData = getChatConversationsFromCache({
      id: chatId,
      organizationId,
    });

    await client.mutate({
      mutation: markMessageV3ReadMutation,
      variables: {
        input: {
          chatId,
        },
        portalType: "PLANNER",
      },
    });

    //1.pick first (last) message as lastReadMessage
    const lastMessage = _.first(_.get(mainData, "messagesV2.edges", []));

    if (_.isNil(lastMessage)) return;

    const lastReadMessage = {
      cursor: lastMessage?.cursor,
      id: _.get(lastMessage, "node.id"),
      __typename: "MessageV2",
    };
    //update unread count also
    const dataToSend = { ...mainData, unreadMessageCount: 0 };

    //change last read message in cache
    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId: getUserId(),
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
      lastReadMessage: { $set: lastReadMessage },
    });

    const unreadMessageCount = _.get(
      chatDetailsCacheData,
      "unreadMessageCount",
      0
    );

    const isChat = _.isEqual(
      _.get(chatDetailsCacheData, "type"),
      CHAT_TYPE_BE.CHAT_PERSONAL
    );

    //if there are any unread message count for chat then only reduce overall number
    if (unreadMessageCount) {
      const chatResult = getChatUnreadCountQueryFromCache({
        ...getUnreadChatsCountQueryVariables(),
        portalType: "PLANNER",
      });

      const unReadCountData = _.get(chatResult, "node.chats");

      const allUnreadCount = _.get(unReadCountData, "allUnreadCount", 0);
      const channelUnreadCount = _.get(
        unReadCountData,
        "channelUnreadCount",
        0
      );
      const chatUnreadCount = _.get(unReadCountData, "chatUnreadCount", 0);

      const updatedUnreadCountData = {
        ...unReadCountData,
        allUnreadCount: _.max([0, allUnreadCount - 1]),
      };

      if (isChat) {
        updatedUnreadCountData["chatUnreadCount"] = _.max([
          0,
          chatUnreadCount - 1,
        ]);
      } else {
        updatedUnreadCountData["channelUnreadCount"] = _.max([
          0,
          channelUnreadCount - 1,
        ]);
      }

      const toUpdateInCacheData = update(chatResult, {
        node: {
          chats: {
            $set: updatedUnreadCountData,
          },
        },
      });

      writeChatUnreadCountToCache({
        variables: {
          ...getUnreadChatsCountQueryVariables(),
          portalType: "PLANNER",
        },
        data: toUpdateInCacheData,
      });
    }

    writeChatDetailsToCache({
      variables: chatDetailsQueryVariables,
      data: updatedChatDetailsCacheData,
    });

    writeChatConversationsToCache({
      variables: { id: chatId, organizationId },
      chatConversationsData: dataToSend,
    });
  } catch (e) {}
};

export const userChatActivityLog = data => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: insertUserChatActivityLogMutation,
        variables: {
          input: data,
        },
      });
    } catch (e) {}
  };
};

const resetUnreadMessageCountInCache = async ({ chatId }) => {
  const organizationId = getOrganizationId();

  const mainData = getChatConversationsFromCache({
    id: chatId,
    organizationId,
  });

  const dataToSend = { ...mainData, unreadMessageCount: 0 };

  writeChatConversationsToCache({
    variables: { id: chatId, organizationId },
    chatConversationsData: dataToSend,
  });
};

export const markConversationAsRead = async ({
  messageId,
  chatId,
  isChat = false,
  unreadMessageCount,
}) => {
  try {
    const isReadReceiptOptimized = isReadReceiptOptimizationEnabled();

    if (isReadReceiptOptimized) {
      await markMessageAsReadV3({ chatId, isChat, unreadMessageCount });
      return;
    }

    const lastReadPoint = await client.mutate({
      mutation: markMessageV2ReadMutation,
      variables: { messageId, chatId, portalType: "PLANNER" },
      refetchQueries: [
        {
          query: getChatUnreadCountQuery,
          variables: {
            ...getUnreadChatsCountQueryVariables(),
            portalType: "PLANNER",
          },
        },
      ],
    });

    const markMessageV2ReadResponse = _.get(
      lastReadPoint,
      "data.platform.markMessageV2Read"
    );

    if (_.isEmpty(markMessageV2ReadResponse)) return;

    const lastReadMessage = _.pick(markMessageV2ReadResponse, [
      "id",
      "cursor",
      "__typename",
    ]);

    const chatDetailsQueryVariables = getChatDetailsQueryVariables({
      chatId,
      userId: getUserId(),
    });

    const chatDetailsCacheData = getChatDetailsFromCache(
      chatDetailsQueryVariables
    );

    const updatedChatDetailsCacheData = update(chatDetailsCacheData, {
      lastReadMessage: { $set: lastReadMessage },
    });

    writeChatDetailsToCache({
      variables: chatDetailsQueryVariables,
      data: updatedChatDetailsCacheData,
    });

    // TODO: get lastReadMessage id and cursor after reading for this chatId

    const organizationId = getOrganizationId();

    const mainData = getChatConversationsFromCache({
      id: chatId,
      organizationId,
    });

    const dataToSend = { ...mainData, unreadMessageCount: 0 };

    writeChatConversationsToCache({
      variables: { id: chatId, organizationId },
      chatConversationsData: dataToSend,
    });
  } catch (e) {}
};

export const createCustomChannelAndMoveMessages = ({
  userIds,
  chatId,
  dateFrom,
}) => {
  return async dispatch => {
    try {
      const dateFromWithStartOfDay =
        dateFrom && moment(dateFrom).startOf("day");
      const variables = {
        input: {
          chatId,
          userIds,
          ...(dateFromWithStartOfDay
            ? { dateFrom: dateFromWithStartOfDay?.toISOString() }
            : {}),
        },
      };

      const response = await client.mutate({
        mutation: createCustomChannelAndMoveMessagesMutation,
        variables,
      });

      const newChannelData = _.get(
        response,
        "data.platform.createCustomChannelAndMoveMessages"
      );

      dispatch(
        setToastMsg({
          msg: "toastMsgs:successfully_created_the_channel_label",
          locale_params: [
            {
              key: "label",
              value: _.get(newChannelData, "label"),
              isPlainText: true,
            },
          ],
          type: "success",
        })
      );

      const channelId = _.get(newChannelData, "id");
      if (channelId) {
        dispatch(goToChatIdRoute({ chatId: channelId }));
        dispatch(
          setMessagingSections({ section: MESSAGING_SECTIONS.CHANNELS })
        );

        // clear previous chat cache to avoid showing cached data on next visit
        if (dateFromWithStartOfDay) {
          const organizationId = getOrganizationId();

          const mainData = getChatConversationsFromCache({
            id: chatId,
            organizationId,
          });

          // clear chats edges after dateFromWithStartOfDay
          const messagesEdges = _.get(mainData, "messagesV2.edges", []);
          const filteredEdges = _.filter(messagesEdges, ({ node }) => {
            return moment(node.createdAt).isBefore(dateFromWithStartOfDay);
          });

          const dataToSend = update(mainData, {
            messagesV2: {
              edges: { $set: filteredEdges },
            },
          });

          writeChatConversationsToCache({
            variables: { id: chatId, organizationId },
            chatConversationsData: dataToSend,
          });
        }

        const chatType = CHAT_TYPE_ENUM.CHANNEL_CUSTOM;
        dispatch(handleNewMessage({ chatId: channelId, chatType }));
      }
      return true;
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
        })
      );
    }
    return false;
  };
};

export const goToUserProfile = ({
  id,
  userType,
  navigateType = "push",
  curriculumProgramId,
}) => {
  return async (dispatch, getState) => {
    const store = getState();
    switch (userType) {
      case STUDENT: {
        const currentCurriculumProgramId = getSelectedCurriculumId(store);
        dispatch(
          goToStudentProfileRoute({
            studentId: id,
            currentCurriculumProgramId:
              curriculumProgramId || currentCurriculumProgramId,
            navigateType,
          })
        );
        return;
      }
      case STAFF: {
        const activeTab = _.get(store, "login.activeTab");

        const contextMap = {
          schoolSettingsTab: TEACHER_PROFILE_NAV_CONTEXT.SCHOOL,
          accountSettingsTab: TEACHER_PROFILE_NAV_CONTEXT.ACCOUNT_SETTINGS,
          admin: TEACHER_PROFILE_NAV_CONTEXT.ADMIN,
        };
        const context =
          contextMap[activeTab] ?? TEACHER_PROFILE_NAV_CONTEXT.CURRICULUM;

        dispatch(navigateToTeacherProfile({ id, context, navigateType }));

        return;
      }

      case PARENT:
        dispatch(
          goToFamilyProfileRoute({
            familyId: id,
            navigateType,
          })
        );
        return;
    }
  };
};

export const updateDraft = (chatId, value) => ({
  type: UPDATE_DRAFT,
  data: { chatId, value },
});

export const setLoadingState = data => {
  return {
    type: SET_IS_LOADING,
    data,
  };
};

export const setSearchChatLoadingState = data => {
  return {
    type: SET_IS_SEARCH_CHAT_LOADING,
    data,
  };
};

export const setSearchingState = data => {
  return {
    type: SET_IS_SEARCHING,
    data,
  };
};

export const clearDraft = chatId => ({
  type: CLEAR_DRAFT,
  data: { chatId },
});

export const addDraftAttachments = (chatId, attachments) => ({
  type: ADD_DRAFT_ATTACHMENTS,
  data: { chatId, attachments },
});

export const setChatFilters = ({ chatType, filters }) => ({
  type: SET_CHAT_FILTERS,
  payload: { chatType, filters },
});

export const setMessageStatus = ({ messageId, status }) => ({
  type: SET_MESSAGE_STATUS,
  data: { messageId, status },
});

export const setLastReadMessage = ({ chatId, lastReadMessage }) => ({
  type: SET_LAST_READ,
  data: { chatId, lastReadMessage },
});
// messageId: string; status: boolean
export const setSummaryGenerationStatus = ({ messageId, status }) => ({
  type: SET_SUMMARY_GENERATION_STATUS,
  data: { messageId, status },
});

export const setPreservedScrollMessageId = ({ chatId, messageId }) => ({
  type: PRESERVE_SCROLL_MESSAGE_ID,
  payload: { chatId, messageId },
});

export const setSegmentChatType = ({ chatTypeSegment }) => ({
  type: SET_SEGMENT_CHAT_TYPE,
  data: { chatTypeSegment },
});

export const setMessagingSections = ({ section }) => {
  return {
    type: SET_MESSAGING_SECTIONS,
    data: { section },
  };
};

export const setShowSummariesNewMessagesWithAi = data => {
  return {
    type: SET_SHOW_SUMMARISE_NEW_MESSAGES_WITH_AI,
    data,
  };
};

export const setCreateChannelDropdownOpen = data => {
  return {
    type: SET_CREATE_CHANNEL_DROPDOWN_OPEN,
    data,
  };
};

export const setRevampV2FilterSearch = data => {
  return {
    type: SET_MESSAGE_REVAMP_V2_FILTER_SEARCH,
    data,
  };
};

export const setRevampV2SearchFocus = data => {
  return {
    type: SET_MESSAGE_REVAMP_V2_SEARCH_FOCUS,
    data,
  };
};

export const setRevampV2FilterThread = data => {
  return {
    type: SET_MESSAGE_REVAMP_V2_FILTER_THREAD,
    data,
  };
};

export const setShowOverviewModal = data => {
  return {
    type: SET_SHOW_OVERVIEW_MODAL,
    data,
  };
};

export const setInitAddMemberModalId = data => {
  return {
    type: SET_INIT_ADD_MEMBER_MODAL,
    data,
  };
};

export const setIniFormSubmittedModal = data => {
  return {
    type: SET_INIT_FORM_SUBMITTED_MODAL,
    data,
  };
};

export const setFormTemplateModal = data => {
  return {
    type: SET_FORM_TEMPLATE_MODAL_STATE,
    data,
  };
};

const defaultChatFilters = { selectedUserTypes: [] };
const defaultChannelFilters = { selectedChannelTypes: [] };

const MAP_FILTERS_TO_SEGMENT = {
  [CHAT_TYPE.CHAT]: defaultChatFilters,
  [CHAT_TYPE.CHANNEL]: defaultChannelFilters,
};

const initialState = {
  searchText: "",
  searchV2Tags: [],
  searchV2Text: "",
  searchV2LastTab: "",
  isLoading: false,
  isSearchChatLoading: false,
  isSearchingInOpenedChat: false,
  mediaViewerData: null, // null | { attachments: Attachment[], activeAttachmentIndex: number }
  drafts: {},
  messageStatus: {},
  showUnreadMessageButton: false,
  lastReadMessageState: {},
  summaryGenerationStatus: {}, // key: messageId(local messageId of summary message), value: true/false
  aiSuggestions: {}, // key: chatId, value: { suggestion: string[], isLoading: boolean }
  preservedScrollMessageIds: {},
  chatTypeSegment: CHAT_TYPE.CHAT,
  selectedSectionV2: CHAT_TYPE.CHAT,
  showSummariseNewMessagesWithAi: true,
  createChannelDropdownOpen: false,
  messageRevampV2FilterState: {
    threadFilter: null,
    searchFilter: "",
    isSearchFocused: false,
  },
  initAddMemberModalId: null,
  initFormRespondedModal: {
    chatId: null,
    formId: null,
    messageId: null,
  },
  formTemplateModal: false,
  showOverviewModal: false,
  department: {
    searchText: "",
    status: DEPARTMENT_STATUSES.ALL,
  },
  ...MAP_FILTERS_TO_SEGMENT,
};

const REDUCER_HANDLERS = {
  [UPDATE_SEARCH_TEXT]: (state, action) => {
    return update(state, {
      searchText: {
        $set: action.data,
      },
    });
  },
  [UPDATE_SEARCH_V2_TEXT]: (state, action) => {
    return update(state, {
      searchV2Text: {
        $set: action.data,
      },
    });
  },
  [UPDATE_SEARCH_V2_TAGS]: (state, action) => {
    return update(state, {
      searchV2Tags: {
        $set: action.data,
      },
    });
  },
  [UPDATE_SEARCH_V2_LAST_TAB]: (state, action) => {
    return update(state, {
      searchV2LastTab: {
        $set: action.data,
      },
    });
  },
  [SET_MEDIA_VIEWER_MODAL_STATE]: (state, action) => {
    return update(state, {
      mediaViewerData: {
        $set: _.get(action, "data", null),
      },
    });
  },
  [SET_IS_LOADING]: (state, action) => {
    return update(state, {
      isLoading: {
        $set: action.data,
      },
    });
  },
  [SET_IS_SEARCH_CHAT_LOADING]: (state, action) => {
    return update(state, {
      isSearchChatLoading: {
        $set: action.data,
      },
    });
  },
  [SET_IS_SEARCHING]: (state, action) => {
    return update(state, {
      isSearchingInOpenedChat: {
        $set: action.data,
      },
    });
  },
  [UPDATE_DRAFT]: (state, action) => {
    const { chatId, value } = action.data;
    const oldDraftState = state.drafts[chatId] || getInitialDraftData();
    const updatedDraftState = update(oldDraftState, { $merge: value });

    if (isDraftStateEmpty(updatedDraftState)) {
      return update(state, { drafts: { $unset: [chatId] } });
    }

    return update(state, {
      drafts: {
        [chatId]: { $set: updatedDraftState },
      },
    });
  },
  [CLEAR_DRAFT]: (state, action) => {
    const { chatId } = action.data;

    // if there is no draft for this chat then do nothing
    if (!_.get(state, ["drafts", chatId])) return state;

    return update(state, {
      drafts: {
        $unset: [chatId],
      },
    });
  },
  [ADD_DRAFT_ATTACHMENTS]: (state, action) => {
    const { chatId, attachments } = action.data;
    const oldDraftState = state.drafts[chatId] || getInitialDraftData();
    const updatedDraftState = addAttachmentsInDraftState({
      draft: oldDraftState,
      attachments,
    });

    return update(state, {
      drafts: {
        [chatId]: { $set: updatedDraftState },
      },
    });
  },
  [SET_CHAT_FILTERS]: (state, action) => {
    const { chatType, filters } = action.payload;
    return update(state, {
      [chatType]: { $merge: filters },
    });
  },
  [SET_MESSAGE_STATUS]: (state, action) => {
    const { messageId, status } = action.data;
    return status
      ? update(state, {
          messageStatus: {
            [messageId]: { $set: status },
          },
        })
      : update(state, {
          messageStatus: {
            $unset: [messageId],
          },
        });
  },
  [SET_SHOW_UNREAD_MESSAGE_BUTTON]: (state, action) => {
    return update(state, {
      showUnreadMessageButton: {
        $set: action.data,
      },
    });
  },
  [SET_LAST_READ]: (state, action) => {
    const { chatId, lastReadMessage } = action.data;
    return lastReadMessage
      ? update(state, {
          lastReadMessageState: {
            [chatId]: { $set: lastReadMessage },
          },
        })
      : update(state, {
          lastReadMessageState: {
            $unset: [chatId],
          },
        });
  },
  [PRESERVE_SCROLL_MESSAGE_ID]: (state, action) => {
    const { chatId, messageId } = action.payload;
    return messageId
      ? update(state, {
          preservedScrollMessageIds: {
            [chatId]: { $set: messageId },
          },
        })
      : update(state, {
          preservedScrollMessageIds: {
            $unset: [chatId],
          },
        });
  },
  [SET_SUMMARY_GENERATION_STATUS]: (state, action) => {
    const { messageId, status } = action.data;
    return status
      ? update(state, {
          summaryGenerationStatus: {
            [messageId]: { $set: status },
          },
        })
      : update(state, {
          summaryGenerationStatus: {
            $unset: [messageId],
          },
        });
  },
  [SET_SUGGESTION_GENERATION_REQUESTED]: (state, action) => {
    const { chatId } = action.payload;
    return {
      ...state,
      aiSuggestions: {
        ...state.aiSuggestions,
        [chatId]: {
          ..._.get(state, ["aiSuggestions", chatId], {
            suggestions: [],
          }),
          isLoading: true,
        },
      },
    };
  },
  [SET_SUGGESTION_GENERATION_COMPLETED]: (state, action) => {
    const { chatId, suggestions } = action.payload;
    return update(state, {
      aiSuggestions: {
        [chatId]: {
          $set: {
            suggestions,
            isLoading: false,
          },
        },
      },
    });
  },
  [REMOVE_CHAT_SUGGESTIONS]: (state, action) => {
    if (!_.get(state, ["aiSuggestions", action.payload.chatId])) return state;

    const { chatId } = action.payload;
    return update(state, { aiSuggestions: { $unset: [chatId] } });
  },
  [SET_SEGMENT_CHAT_TYPE]: (state, action) => {
    const { chatTypeSegment } = action.data;
    // on segment change, reset the filters for that segment
    return update(state, {
      chatTypeSegment: { $set: chatTypeSegment },
      [chatTypeSegment]: { $set: MAP_FILTERS_TO_SEGMENT[chatTypeSegment] },
    });
  },
  [SET_MESSAGING_SECTIONS]: (state, action) => {
    const { section } = action.data;
    // on segment change, reset the filters for that segment

    if (
      _.includes(
        [MESSAGING_SECTIONS.CHAT, MESSAGING_SECTIONS.CHANNELS],
        section
      )
    ) {
      return update(state, {
        selectedSectionV2: { $set: section },
        [section]: { $set: MAP_FILTERS_TO_SEGMENT[section] },
      });
    } else {
      return update(state, {
        selectedSectionV2: { $set: section },
      });
    }
  },
  [SET_SHOW_SUMMARISE_NEW_MESSAGES_WITH_AI]: (state, action) => {
    return update(state, {
      showSummariseNewMessagesWithAi: {
        $set: action.data,
      },
    });
  },
  [SET_CREATE_CHANNEL_DROPDOWN_OPEN]: (state, action) => {
    return update(state, {
      createChannelDropdownOpen: {
        $set: action.data,
      },
    });
  },
  [SET_MESSAGE_REVAMP_V2_FILTER_THREAD]: (state, action) => {
    return update(state, {
      messageRevampV2FilterState: {
        threadFilter: {
          $set: action.data,
        },
      },
    });
  },
  [SET_MESSAGE_REVAMP_V2_FILTER_SEARCH]: (state, action) => {
    return update(state, {
      messageRevampV2FilterState: {
        searchFilter: {
          $set: action.data,
        },
      },
    });
  },
  [SET_MESSAGE_REVAMP_V2_SEARCH_FOCUS]: (state, action) => {
    return update(state, {
      messageRevampV2FilterState: {
        isSearchFocused: {
          $set: action.data,
        },
      },
    });
  },
  [SET_SHOW_OVERVIEW_MODAL]: (state, action) => {
    return update(state, {
      showOverviewModal: {
        $set: action.data,
      },
    });
  },
  [SET_INIT_ADD_MEMBER_MODAL]: (state, action) => {
    return update(state, {
      initAddMemberModalId: {
        $set: action.data,
      },
    });
  },
  [SET_INIT_FORM_SUBMITTED_MODAL]: (state, action) => {
    return update(state, {
      initFormRespondedModal: {
        $set: action.data,
      },
    });
  },
  [SET_FORM_TEMPLATE_MODAL_STATE]: (state, action) => {
    return update(state, {
      formTemplateModal: {
        $set: action.data,
      },
    });
  },
  [UPDATE_DEPARTMENT_SEARCH_TEXT]: (state, action) => {
    return update(state, {
      department: {
        searchText: {
          $set: action.data,
        },
      },
    });
  },
  [UPDATE_DEPARTMENT_STATUS]: (state, action) => {
    return update(state, {
      department: {
        status: {
          $set: action.data,
        },
      },
    });
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
